import React, { Component } from 'react';
import { Redirect } from 'react-router';
import Grid from '@material-ui/core/Grid';
import parse from 'html-react-parser';
import Swal from 'sweetalert2';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { fade, Typography, useTheme } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Popover from '@material-ui/core/Popover';
import Toolbar from '@material-ui/core/Toolbar';
import { countriesBIH, countriesHR, countriesEN } from '../../../@jumbo/constants/AppConstants';
import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';
import ControlPointDuplicateIcon from '@material-ui/icons/ControlPointDuplicate';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Slide from '@material-ui/core/Slide';

//import Calendar from './index';
import Box from '@material-ui/core/Box';
import CmtGridView from '../../../@coremat/CmtGridView';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import ViewCC from './ViewCC.js';
import AddCC from './AddCC.js';
import ViewClient from './ViewClient.js';
import Modal from '@material-ui/core/Modal';
import {
  getMyDate4,
  getMyDate3,
  getMyDate2,
  myFormatPrice,
  formatPrice,
  myGetNumber,
  countriesx,
} from '../../../@jumbo/utils/commonHelper';
import Invoice from '../invoices/Invoice';
import { injectIntl } from 'react-intl';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { Cancel, CloudDone, Loyalty } from '@material-ui/icons';
import MenuItem from '@material-ui/core/MenuItem';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import GridContainer from '../../../@jumbo/components/GridContainer';
import { KeyboardDatePicker, DatePicker, DateTimePicker } from '@material-ui/pickers';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ModifyRoom from './ModifyRoom';
import AddRoom from './AddRoom';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Messages from '../messages/index.js';
import ViewTAClient from '../quickreservation/ViewTAClient';
//import Messages from '../messages/index';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

const rstyle = {
  /*position: 'absolute',
  top: '50%',
  left: '50%',*/
  /* transform: 'translate(-50%, -50%)',*/
  '@media screen and (max-width: 800px)': {
    width: '100%',
  },
  '@media screen and (min-width: 800px)': {
    width: '50%',
  },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

function getMyDate(prop) {
  var md = new Date(prop);
  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = theme => ({
  mainBox: {
    width: '90%',
  },

  boxTop: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  boxTop2: {
    marginLeft: theme.spacing(5),
    marginBottom: theme.spacing(5),
    marginRight: theme.spacing(5),
    marginTop: theme.spacing(5),
  },
  appBar: {
    position: 'relative',
  },
  myButton: {
    margin: theme.spacing(2),
    minWidth: 200,
    marginLeft: 0,
  },
  root: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },

  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 10,
      paddingBottom: 0,
    },
  },
  tabsList: {
    position: 'relative',
    minHeight: 60,
    '& .MuiTabs-indicator': {
      backgroundColor: fade(theme.palette.primary.main, 0.8),
    },
  },
  tabItem: {
    maxWidth: 'none',
    minWidth: 10,
    minHeight: 60,
    padding: '5px 10px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
  },
  columnRoot: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.5px',
  },
});

const style = {
  position: 'absolute',
  top: '0%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function createData(name, dateOfBirth, sex, city, country) {
  return { name, dateOfBirth, sex, city, country };
}

class ResDetails extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;
    var readOnly = false;
    if (this.props.auth.authUser.clouduser == 0 && this.props.auth.authUser.role == 20) {
      readOnly = true;
    }

    this.handleClose = this.handleClose.bind(this);
    this.handleClose2 = this.handleClose2.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.handleCCClose = this.handleCCClose.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.getExtraType = this.getExtraType.bind(this);
    this.getMealPlan = this.getMealPlan.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.refresh = this.refresh.bind(this);
    this.state = {
      data: {},
      data2: {},
      rows: [],
      paymentLink: '',
      origRows: [],
      agencyId: -1,
      paymentAmount: 0,
      sendEmailPayment: false,
      resId: props.resId,
      hotelId: props.hotelId,
      tabroom: 0,
      redirect: false,
      viewClientVisible: false,
      refundAmount: 0,
      refundDialog: false,
      modifyRoomVisible: false,
      addRoomVisible: false,
      invoiceMode: '',
      invoiceId: '',

      comment: '',

      guestName: '',
      guestPhone: '',
      guestBirth: '',
      guestCompany: '',
      guestVat: '',
      guestEmail: '',
      addEmail: '',
      guestCountry: '',
      readOnly: readOnly,
      guestCity: '',
      customPrepaymentMode: -1,
      customPrepayment: '',
      showFail: false,
      showSuccess: false,
      customPrepayment2: 100,
      viewTAVisible: false,
      discountMode: 1,
      appDiscount: 0,
      extrasDiscountVisible: false,
      selExtraId: -1,

      origGuestName: '',
      origGuestPhone: '',
      origGuestBirth: '',
      origGuestCompany: '',
      origGuestVat: '',
      origGuestEmail: '',
      origAddEmail: '',
      newEQuantity: 1,
      origGuestCountry: '',
      origGuestCity: '',
      guestInfo: [],
      confirmationLanguage: 'en',
      invoices: [],
      activities: [],
      extras: [],
      totalPrice: 0,
      origTotalPrice: 0,
      totalAdults: 0,
      totalKids: 0,
      status: '',
      channel: '',
      color: '',
      fontcolor: '',
      sci: [],
      setFreeCancel: false,
      freeCancel: null,
      setDueDate: false,
      ignoreAnalytics: false,
      dueDate: null,
      autoCancel: false,
      viewInvoiceVisible: false,
      addVoucherVisible: false,
      voucherNumber: '',
      addVoucherVisible2: false,
      addPaymentProof: false,
      createPrepayment: 0,
      viewCCVisible: false,
      myanchorEl: null,
    };
  }
  handleClickOpen() {
    //  setOpen(true);
  }

  handleClose2() {
    this.setState({ showFail: false, showSuccess: false });
    //  setOpen(false);
  }

  getMealPlan(x) {
    var rf = this.props.auth.authUser.rates.filter(function(itemx) {
      return itemx.id == x;
    });
    if (rf.length == 1) {
      var mealPlan = rf[0].mealPlan;
      if (mealPlan == 0) return 'Only accommodaiton';
      if (mealPlan == 1) return 'Breakfast included';
      if (mealPlan == 2) return 'Halfboard';
      if (mealPlan == 3) return 'Fullboard';
      if (mealPlan == 4) return 'All inclusive';
    }
  }

  getExtraType(x) {
    const { intl } = this.props;
    if (x == 0) return intl.formatMessage({ id: 'extras.type0' });
    if (x == 1) return intl.formatMessage({ id: 'extras.type1' });
    if (x == 2) return intl.formatMessage({ id: 'extras.type2' });
    if (x == 3) return intl.formatMessage({ id: 'extras.type3' });
    if (x == 4) return intl.formatMessage({ id: 'extras.type4' });
  }

  handleAction(name, index) {
    if (name == 'agencyId') {
      const token = localStorage.getItem('token');
      var Data = [];
      var item2 = {};
      item2.bookingId = this.state.res.data.Data[0].id;
      item2.send = 1;
      item2.status = 0;
      item2.email = this.state.guestEmail;
      item2.language = this.state.confirmationLanguage;
      item2.hotelId = this.state.res.data.Data[0].hotel_id;
      Data.push(item2);

      const senddata = {
        Action: 'changeResTA',
        token: token,
        Version: 1,
        Data: {
          bookingId: this.state.res.data.Data[0].id,
          agencyId: index,
        },
      };
      //alert(JSON.stringify(senddata));
      var pmsUrl = this.props.auth.authUser.pmsUrl;
      const { intl } = this.props;
      if (pmsUrl == '') return;
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        this.refresh();
      });
      return;
    }
    if (name == 'sendinvitation') {
      const token = localStorage.getItem('token');
      var Data = [];
      var item2 = {};
      item2.bookingId = this.state.res.data.Data[0].id;
      item2.send = 1;
      item2.status = 0;
      item2.email = this.state.guestEmail;
      item2.language = this.state.confirmationLanguage;
      item2.hotelId = this.state.res.data.Data[0].hotel_id;
      Data.push(item2);

      const senddata = {
        Action: 'sendSCI',
        token: token,
        Version: 1,
        Data: Data,
      };
      //alert(JSON.stringify(senddata));
      var pmsUrl = this.props.auth.authUser.pmsUrl;
      const { intl } = this.props;
      if (pmsUrl == '') return;
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        this.refresh();
      });
      return;
    }
    if (name == 'addnew') {
      var defaultIdType = '1';
      var defaultSex = 'M';
      if (
        this.props.auth.authUser.hotels.find(({ id }) => id === this.state.hotel_id).EV == 1 &&
        this.props.auth.authUser.hotels.find(({ id }) => id === this.state.hotel_id).engine == 0
      ) {
        defaultIdType = '027';
        defaultSex = 0;
      }
      if (
        this.props.auth.authUser.hotels.find(({ id }) => id === this.state.hotel_id).EV == 1 &&
        this.props.auth.authUser.hotels.find(({ id }) => id === this.state.hotel_id).engine == 1
      ) {
        defaultIdType = '2';
        defaultSex = 1;
      }

      var gi = {
        FirstName: '',
        LastName: '',
        Sex: defaultSex,
        BirthDate: '1950-01-01',
        BirthCountry: '',
        BirthCity: '',
        idType: defaultIdType,
        guestTax: 'N',
        idNumber: '',
        City: '',
        RoomId: this.state.rows[0].room_id,
        Country: '',
        Citizenship: '',
      };
      this.setState(prevState => {
        var rs = [...prevState.guestInfo];
        rs.push(gi);
        return { guestInfo: rs };
      });
    }
    if (name == 'delete') {
      this.setState(prevState => {
        var rs = [...prevState.guestInfo];
        rs.splice(index, 1);
        return { guestInfo: rs };
      });
    }
    if (name == 'openCheckIn') {
      window.open(this.state.sci[index]);
      /*  ,
      );*/
    }
    if (name == 'checkIn' || name == 'checkIn2') {
      const token = localStorage.getItem('token');
      var senddata = {};
      if (name == 'checkIn')
        senddata = {
          Action: 'checkin_reservation',
          token: token,
          Version: 1,
          Data: {
            ReservationId: this.state.res.data.Data[0].id,
            guestInfo: this.state.guestInfo,
          },
        };
      else
        senddata = {
          Action: 'save_guests',
          token: token,
          Version: 1,
          Data: {
            ReservationId: this.state.res.data.Data[0].id,
            guestInfo: this.state.guestInfo,
          },
        };

      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        this.props.setState({ lastEvents: [], running2: false });
        if (this.props.doRefresh != null) this.props.doRefresh();
        if (this.props.doLoadResources != null) this.props.doLoadResources();
        this.refresh();
        this.props.setState({ resDetailsVisible: false });

        /*this.setState(prevState => {
          return {
            changed: false,
            origGuestName: prevState.guestName,
            origGuestCity: prevState.guestCity,
            origGuestCountry: prevState.guestCountry,
            origGuestPhone: prevState.guestPhone,
            origGuestEmail: prevState.guestEmail,

            origTotalPrice: prevState.totalPrice,
            origComment: prevState.comment,
            origRows: prevState.rows,
          };
        });*/
      });
    }
  }
  handleTabChange(event, newValue) {
    this.setState({ tabroom: newValue });
  }
  handleClick(event, action, index = -1) {
    const { intl } = this.props;
    if (action == 'viewCC') {
      this.setState({ myanchorEl: event.currentTarget, viewCCVisible: true, selReservationId: this.state.resId });
    }
    if (action == 'addCC') {
      this.setState({ myanchorEl: event.currentTarget, viewAddCCVisible: true, selReservationId: this.state.resId });
    }
    if (action == 'refundShow') {
      this.setState({ selInvoiceId: index.id, refundAmount: index.total, refundDialog: true });
    }

    if (action == 'refund') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'refundInvoice',
        token: token,
        Version: 1,
        Data: {
          invoiceId: this.state.selInvoiceId,
          amount: this.state.refundAmount,
        },
      };
      // alert(JSON.stringify(senddata));
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        if (this.props.doRefresh != null) this.props.doRefresh();
        this.refresh();
      });
    }

    if (action == 'addEItem') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'addEItem',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.state.res.data.Data[0].id,
          service_id: this.state.newEService_id,
          quantity: this.state.newEQuantity,
        },
      };
      // alert(JSON.stringify(senddata));
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        if (this.props.doRefresh != null) this.props.doRefresh();
        this.refresh();
      });
    }
    if (action == 'savePaymentInfo') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'savePaymentInfo',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.state.res.data.Data[0].id,
          paymentId: this.state.paymentId,
          customPrepaymentMode: this.state.customPrepaymentMode,
          customPrepayment: this.state.customPrepayment,
          customPrepayment2: this.state.customPrepayment2,
        },
      };
      // alert(JSON.stringify(senddata));
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        //        if (this.props.doRefresh != null) this.props.doRefresh();
        this.refresh();
      });
    }
    if (action == 'requestPayment') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'requestPayment',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.state.res.data.Data[0].id,
          HotelId: this.state.hotel_id,
          amount: myGetNumber(this.state.paymentAmount, this.props.auth.authUser.numberMode),
          paymentId: this.state.paymentId,
          sendEmail: this.state.sendEmailPayment,
        },
      };
      // alert(JSON.stringify(senddata));
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        this.setState({ paymentLink: res.data.paymentLink });
      });
    }
    if (action == 'doPayment') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'doPayment',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.state.res.data.Data[0].id,
          HotelId: this.state.hotel_id,
          amount: this.state.customPrepayment2,
          paymentId: this.state.paymentId,
        },
      };
      // alert(JSON.stringify(senddata));
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        this.setState({ paymentLink: res.data.paymentLink });
      });
    }
    if (action == 'modifyEDiscont') {
      this.setState({ extrasDiscountVisible: true, selExtraId: event });
    }
    if (action == 'modifyEDiscount2') {
      var reason = '';
      if (this.state.discountMode == 0) reason = this.state.reason;
      else {
        if (this.state.discountMode == 1) reason = intl.formatMessage({ id: 'modify1' });
        if (this.state.discountMode == 2) reason = intl.formatMessage({ id: 'modify2' });
        if (this.state.discountMode == 3) reason = intl.formatMessage({ id: 'modify3' });
        if (this.state.discountMode == 4) reason = intl.formatMessage({ id: 'modify4' });
        if (this.state.discountMode == 5) reason = intl.formatMessage({ id: 'modify5' });
        if (this.state.discountMode == 6) reason = intl.formatMessage({ id: 'modify6' });
        if (this.state.discountMode == 7) reason = intl.formatMessage({ id: 'fy7' });
        if (this.state.discountMode == 8) reason = intl.formatMessage({ id: 'modify8' });
        if (this.state.discountMode == 9) reason = intl.formatMessage({ id: 'modify9' });
        if (this.state.discountMode == 10) reason = intl.formatMessage({ id: 'modify10' });
        if (this.state.discountMode == 11) reason = intl.formatMessage({ id: 'modify11' });
        if (this.state.discountMode == 12) reason = intl.formatMessage({ id: 'modify12' });
        if (this.state.discountMode == 13) reason = intl.formatMessage({ id: 'modify13' });
        if (this.state.discountMode == 14) reason = intl.formatMessage({ id: 'modify14' });
        if (this.state.discountMode == 15) reason = intl.formatMessage({ id: 'modify15' });
      }
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'modifyEItemDiscount',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.state.res.data.Data[0].id,
          extraId: this.state.selExtraId,
          discount: this.state.appDiscount,
          reason: reason,
        },
      };
      // alert(JSON.stringify(senddata));
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        this.setState({ extrasDiscountVisible: false }, () => {
          if (this.props.doRefresh != null) this.props.doRefresh();
          this.refresh();
        });
      });
    }
    if (action == 'deleteEItem') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'deleteEItem',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.state.res.data.Data[0].id,
          rowId: event,
        },
      };
      //alert(JSON.stringify(senddata));
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        if (this.props.doRefresh != null) this.props.doRefresh();
        this.refresh();
      });
    }
    if (action == 'findClient') {
      this.setState({ myanchorEl: event.currentTarget, viewClientVisible: true, selReservationId: this.state.resId });
    }
    if (action == 'changeTA') {
      this.setState({ myanchorEl: event.currentTarget, viewTAVisible: true, selReservationId: this.state.resId });
    }
    if (action == 'newClient') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'setReservationClient',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.state.resId,
          ClientId: -1,
        },
      };
      //alert(JSON.stringify(senddata));
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (this.props.doRefresh != null) this.props.doRefresh();
        this.refresh();
      });
    }
    if (action == 'getGuest') {
      this.setState({
        myanchorEl: event.currentTarget,
        viewClientVisible: true,
        selReservationId: '-3',
        selGuestIndex: index,
      });
    }
    if (action == 'deletereservationrooom') {
      Swal.fire({
        title: intl.formatMessage({ id: 'bookings.confirmation' }),
        text: intl.formatMessage({ id: 'deleteRoomConfirmation' }),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: intl.formatMessage({ id: 'yes' }),
        cancelButtonText: intl.formatMessage({ id: 'no' }),
      }).then(result => {
        if (result.isConfirmed) {
          const token = localStorage.getItem('token');
          const senddata = {
            Action: 'deletereservationrooom',
            token: token,
            Version: 1,
            Data: {
              reservationId: this.state.res.data.Data[0].id,
              reservationRoom: index,
            },
          };

          axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
            this.props.setState({ lastEvents: [], running2: false });
            if (this.props.doRefresh != null) this.props.doRefresh();
            this.refresh();
          });
        }
      });
    }
    if (action == 'modifyreservation') {
      this.setState({ myanchorEl: event.currentTarget, modifyRoomVisible: true, selReservationRoom: index });
    }
    if (action == 'addroom') {
      this.setState({
        myanchorEl: event.currentTarget,
        addRoomVisible: true,
        selReservation: this.state.res.data.Data[0].id,
        selReservationRoom: this.state.rows[0],
      });
    }

    if (action == 'tabCheckIn') {
      this.setState({ tabroom: 2 });
    }
    if (action == 'downloadConfirmation') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'downloadConfirmation',
        token: token,
        Version: 1,
        Data: {
          Language: this.state.confirmationLanguage,
          ReservationId: this.state.res.data.Data[0].id,
        },
      };

      const config = { responseType: 'blob' };
      const filename = this.state.res.data.Data[0].booking_number + '.pdf';
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata, config).then(res => {
        //this.props.setState({ lastEvents: [], running2: false });
        //if (this.props.doRefresh != null) this.props.doRefresh();
        //this.refresh();
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    }
    if (action == 'downloadConfirmation2') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'downloadConfirmation2',
        token: token,
        Version: 1,
        Data: {
          Language: this.state.confirmationLanguage,
          ReservationId: this.state.res.data.Data[0].id,
        },
      };

      const config = { responseType: 'blob' };
      const filename = this.state.res.data.Data[0].booking_number + '.pdf';
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata, config).then(res => {
        //this.props.setState({ lastEvents: [], running2: false });
        //if (this.props.doRefresh != null) this.props.doRefresh();
        //this.refresh();
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    }

    if (action == 'sendConfirmation') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'sendConfirmation',
        token: token,
        Version: 1,
        Data: {
          Language: this.state.confirmationLanguage,
          ReservationId: this.state.res.data.Data[0].id,
          email: this.state.guestEmail,
        },
      };

      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        //this.props.setState({ lastEvents: [], running2: false });
        //if (this.props.doRefresh != null) this.props.doRefresh();
        //this.refresh();
      });
    }

    if (action == 'confirm') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'confirmReservation',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.state.res.data.Data[0].id,
        },
      };

      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        if (res.data.success == 'false' && res.data.reason == 1) {
          Swal.fire({
            title: intl.formatMessage({ id: 'bookings.confirmation' }),
            text: intl.formatMessage({ id: 'confirmReservationAsOverBooking' }),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: intl.formatMessage({ id: 'yes' }),
            cancelButtonText: intl.formatMessage({ id: 'no' }),
          }).then(result => {
            if (result.isConfirmed) {
              const token = localStorage.getItem('token');
              const senddata = {
                Action: 'confirmReservation',
                token: token,
                Version: 1,
                Data: {
                  ReservationId: this.state.res.data.Data[0].id,
                  force: 1,
                },
              };

              axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
                this.props.setState({ lastEvents: [], running2: false });
                if (this.props.doRefresh != null) this.props.doRefresh();
                this.refresh();
              });
            }
          });
        } else {
          if (this.props.doRefresh != null) this.props.doRefresh();
          this.refresh();
        }
        this.props.setState({ lastEvents: [], running2: false });
      });
    }
    if (action == 'openExtranet') {
      const newWindow = window.open(this.state.res.data.Data[0].externalUrl, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    }
    if (action == 'unconfirmPMS') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'unconfirmPMS',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.state.res.data.Data[0].id,
        },
      };

      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        this.props.setState({ lastEvents: [], running2: false });
        if (this.props.doRefresh != null) this.props.doRefresh();
        this.refresh();
      });
    }
    if (action == 'doCheckOut') {
      let balance = this.state.res.data.Data[0].Balance;
      if (balance != 0) {
        Swal.fire({
          title: intl.formatMessage({ id: 'bookings.confirmation' }),
          text: intl.formatMessage({ id: 'bookings.foliosOpened' }),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: intl.formatMessage({ id: 'yes' }),
          cancelButtonText: intl.formatMessage({ id: 'no' }),
        }).then(result => {
          if (result.isConfirmed) {
            //  return;
            const token = localStorage.getItem('token');
            const senddata = {
              Action: 'checkout_reservation',
              token: token,
              Version: 1,
              Data: {
                ReservationId: this.state.res.data.Data[0].id,
              },
            };

            axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
              this.props.setState({ lastEvents: [], running2: false });
              if (this.props.doRefresh != null) this.props.doRefresh();
              if (this.props.doLoadResources != null) this.props.doLoadResources();
              this.refresh();
              this.props.setState({ resDetailsVisible: false });

              /*this.setState(prevState => {
                return {
                  changed: false,
                  origGuestName: prevState.guestName,
                  origGuestCity: prevState.guestCity,
                  origGuestCountry: prevState.guestCountry,
                  origGuestPhone: prevState.guestPhone,
                  origGuestEmail: prevState.guestEmail,

                  origTotalPrice: prevState.totalPrice,
                  origComment: prevState.comment,
                  origRows: prevState.rows,
                };
              });*/
            });
          }
        });
      } else {
        const token = localStorage.getItem('token');
        const senddata = {
          Action: 'checkout_reservation',
          token: token,
          Version: 1,
          Data: {
            ReservationId: this.state.res.data.Data[0].id,
          },
        };

        axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
          this.props.setState({ lastEvents: [], running2: false });
          if (this.props.doRefresh != null) this.props.doRefresh();
          if (this.props.doLoadResources != null) this.props.doLoadResources();
          this.refresh();
          this.props.setState({ resDetailsVisible: false });

          /*this.setState(prevState => {
            return {
              changed: false,
              origGuestName: prevState.guestName,
              origGuestCity: prevState.guestCity,
              origGuestCountry: prevState.guestCountry,
              origGuestPhone: prevState.guestPhone,
              origGuestEmail: prevState.guestEmail,

              origTotalPrice: prevState.totalPrice,
              origComment: prevState.comment,
              origRows: prevState.rows,
            };
          });*/
        });
      }
    }
    if (action == 'createInvoice') {
      this.setState({
        selReservationId: this.state.resId,
        invoiceMode: 'create',
        createPrepayment: 0,
        viewInvoiceVisible: true,
      });
    }
    if (action == 'createInvoice2') {
      this.setState({
        selReservationId: this.state.resId,
        invoiceMode: 'create',
        createPrepayment: 1,
        viewInvoiceVisible: true,
      });
    }
    if (action == 'viewInvoice') {
      this.setState({ invoiceMode: 'view', viewInvoiceVisible: true });
    }
    if (action == 'downloadVoucher') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'downloadVoucher',
        token: token,
        Version: 1,
        Data: {
          //ReservationId: this.state.res.data.Data[0].id,
          reservationId: this.state.resId,
        },
      };

      const config = { responseType: 'blob' };
      const filename = 'Voucher-' + this.state.res.data.Data[0].booking_number + '.pdf';
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata, config).then(res => {
        //this.props.setState({ lastEvents: [], running2: false });
        //if (this.props.doRefresh != null) this.props.doRefresh();
        //this.refresh();
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    }
    if (action == 'downloadPaymentProof') {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'downloadPaymentProof',
        token: token,
        Version: 1,
        Data: {
          //ReservationId: this.state.res.data.Data[0].id,
          reservationId: this.state.resId,
        },
      };

      const config = { responseType: 'blob' };
      const filename = 'Payment-' + this.state.res.data.Data[0].booking_number + '.pdf';
      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata, config).then(res => {
        //this.props.setState({ lastEvents: [], running2: false });
        //if (this.props.doRefresh != null) this.props.doRefresh();
        //this.refresh();
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    }

    if (action == 'addVoucher') {
      const token = localStorage.getItem('token');
      var senddata = {};
      senddata = {
        Action: 'addVoucher',
        token: token,
        Version: 1,
        Data: {
          reservationId: this.state.resId,
        },
      };
      if (this.state.filename != null) {
        var filexi = {
          name: this.state.filename,
          size: this.state.filesize,

          filetype: this.state.filetype,
          b64: this.state.fileb64,
        };
        senddata.Data.filex = [];
        senddata.Data.filex.push(filexi);
      } else return;

      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;

      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        //if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
        if (res.data.success == 1) this.setState({ addVoucherVisible: false, showSuccess: true });
        else this.setState({ addVoucherVisible: false, showFail: true });
        this.refresh();

        //if (this.props.bookingId == null) this.updateActivities();
        //else this.eventClick('open', '', this.state.channelId, this.state.bookingId);
      });
    }
    if (action == 'addPaymentProof') {
      const token = localStorage.getItem('token');
      var senddata = {};
      senddata = {
        Action: 'addPaymentProof',
        token: token,
        Version: 1,
        Data: {
          reservationId: this.state.resId,
        },
      };
      if (this.state.filename != null) {
        var filexi = {
          name: this.state.filename,
          size: this.state.filesize,

          filetype: this.state.filetype,
          b64: this.state.fileb64,
        };
        senddata.Data.filex = [];
        senddata.Data.filex.push(filexi);
      } else return;

      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;

      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        //if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
        if (res.data.success == 1) this.setState({ addPaymentProof: false, showSuccess: true });
        else this.setState({ addPaymentProof: false, showFail: true });
        this.refresh();

        //if (this.props.bookingId == null) this.updateActivities();
        //else this.eventClick('open', '', this.state.channelId, this.state.bookingId);
      });
    }
    if (action == 'addVoucher2') {
      const token = localStorage.getItem('token');
      var senddata = {};
      senddata = {
        Action: 'addVoucher2',
        token: token,
        Version: 1,
        Data: {
          reservationId: this.state.resId,
          voucherNumber: this.state.voucherNumber,
        },
      };

      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;

      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        //if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
        if (res.data.success == 1) this.setState({ addVoucherVisible2: false, showSuccess: true });
        else this.setState({ addVoucherVisible2: false, showFail: true });
        this.refresh();

        //if (this.props.bookingId == null) this.updateActivities();
        //else this.eventClick('open', '', this.state.channelId, this.state.bookingId);
      });
    }
    if (action == 'noShow') {
      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;
      const token = localStorage.getItem('token');
      var x1 = 'bookings.noShow',
        x2 = 'bookings.confirmNoShow';

      Swal.fire({
        title: intl.formatMessage({ id: x2 }),
        text: intl.formatMessage({ id: x2 }),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: intl.formatMessage({ id: 'yes' }),
        cancelButtonText: intl.formatMessage({ id: 'no' }),
      }).then(result => {
        if (result.isConfirmed) {
          //        var r = window.confirm();
          //      if (r == true) {
          const senddata = {
            Action: 'noShow',
            token: token,
            Version: '1',
            Data: {
              HotelId: this.state.hotel_id,
              ResId: this.state.resId,
            },
          };

          //var pmsUrl = this.props.auth.authUser.pmsUrl;
          this.props.setState({ running2: true });
          axios.post(pmsUrl, senddata).then(res => {
            if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
              localStorage.setItem('token', res.data.newToken);
            }
            this.props.setState({ resDetailsVisible: false });
            this.props.setState({ lastEvents: [], running2: false });
            if (this.props.doRefresh != null) this.props.doRefresh();
            this.refresh();
          });
        }
      });
    }

    if (action == 'cancelReservation' || action == 'unCancelReservation') {
      var pmsUrl = this.props.auth.authUser.pmsUrl;
      if (pmsUrl == '') return;
      const token = localStorage.getItem('token');

      if (this.props.auth.authUser.clouduser == 1) {
        console.log('hotel_id' + this.state.hotel_id);
        console.log('hotels', this.props.auth.authUser.hotels);
        var hotelCodes = this.props.auth.authUser.hotels.filter(({ id }) => id == this.state.hotel_id);
        var hotelCode = null;
        if (hotelCodes.length > 0) hotelCode = hotelCodes[0].hotelCode;
        //var hotelCode = this.props.auth.authUser.hotels.filter(({ id }) => id == this.state.hotel_id)[0].hotelCode;
        const senddata2 = {
          Action: 'validate_action',
          token: token,

          Data: {
            HotelId: this.state.hotel_id,
            HotelCode: hotelCode,
            ReservationId: this.state.resId,
            Action: 'cancel_reservation',
            User: this.props.auth.authUser.name,
          },
        };
        axios.post(pmsUrl, senddata2).then(res => {
          if (res.data != null && res.data.Result != null) {
            //self.setState({ lastEvents: [], running2: false });
            if (res.data.Result == true) {
              //var r = window.confirm(res.data.Message);
              //if (r == true) {
              Swal.fire({
                title: intl.formatMessage({ id: 'bookings.cancelReservation' }),
                text: res.data.Message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: intl.formatMessage({ id: 'yes' }),
                cancelButtonText: intl.formatMessage({ id: 'no' }),
              }).then(result => {
                if (result.isConfirmed) {
                  const senddata = {
                    Action: 'cancel_reservation',
                    token: token,

                    Data: {
                      HotelId: this.state.hotel_id,
                      HotelCode: hotelCode,
                      ReservationId: this.state.resId,
                      User: this.props.auth.authUser.name,
                    },
                  };

                  //var pmsUrl = this.props.auth.authUser.pmsUrl;
                  //var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
                  axios.post(pmsUrl, senddata).then(res => {
                    if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
                      localStorage.setItem('token', res.data.newToken);
                    }
                    //self.setState({ lastEvents: [], running2: false });
                    this.props.setState({ resDetailsVisible: false });
                    this.props.setState({ lastEvents: [], running2: false });
                    if (this.props.doRefresh != null) this.props.doRefresh();
                  });
                }
              });
            } else {
              Swal.fire({
                title: intl.formatMessage({ id: 'error' }),
                text: res.data.Message,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: intl.formatMessage({ id: 'ok' }),
              }).then(result => {
                //this.doRefresh();
              });
            }
          }
        });
      } else {
        var x1 = 'bookings.cancelReservation',
          x2 = 'bookings.confirmCancel';
        if (action == 'unCancelReservation') {
          x1 = 'bookings.unCancelReservation';
          x2 = 'bookings.confirmUnCancel';
        }

        Swal.fire({
          title: intl.formatMessage({ id: x2 }),
          text: intl.formatMessage({ id: x2 }),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: intl.formatMessage({ id: 'yes' }),
          cancelButtonText: intl.formatMessage({ id: 'no' }),
        }).then(result => {
          if (result.isConfirmed) {
            //        var r = window.confirm();
            //      if (r == true) {
            const senddata = {
              Action: 'cancelbooking',
              token: token,
              Version: '1',
              Data: {
                HotelId: this.state.hotel_id,
                ResId: this.state.resId,
              },
            };
            if (action == 'unCancelReservation') senddata.Action = 'uncancelbooking';

            //var pmsUrl = this.props.auth.authUser.pmsUrl;
            this.props.setState({ running2: true });
            axios.post(pmsUrl, senddata).then(res => {
              if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
                localStorage.setItem('token', res.data.newToken);
              }
              this.props.setState({ resDetailsVisible: false });
              this.props.setState({ lastEvents: [], running2: false });
              if (this.props.doRefresh != null) this.props.doRefresh();
              this.refresh();
            });
          }
        });
      }
    }
  }

  runAction(event, action) {
    if (action == 'cancel') {
      this.setState(
        prevState => {
          const origRows = JSON.parse(JSON.stringify(prevState.origRows));
          //const rows = [...prevState.rows];

          return {
            changed: false,
            guestName: prevState.origGuestName,
            guestPhone: prevState.origGuestPhone,
            guestBirth: prevState.origGuestBirth,
            guestCompany: prevState.origGuestCompany,
            guestVat: prevState.origGuestVat,
            guestEmail: prevState.origGuestEmail,
            addEmail: prevState.origAddEmail,
            guestCountry: prevState.origGuestCountry,
            guestCity: prevState.origGuestCity,
            totalPrice: prevState.origTotalPrice,
            comment: prevState.origComment,
            rows: origRows,
          };
        },
        () => {
          console.log(this.state.rows);
        },
      );
    }
    if (action == 'save') {
      const token = localStorage.getItem('token');
      var x = this.state.dueDate;
      if (this.state.setDueDate == false) x = null;
      var x3 = this.state.freeCancel;
      if (this.state.setFreeCancel == false) x3 = null;

      var x2 = this.state.ignoreAnalytics;
      if (this.state.ignoreAnalytics == false) x2 = null;
      var myRows = this.state.rows;
      for (var i = 0; i < myRows.length; i++) {
        myRows[i].price = myGetNumber(myRows[i].price, this.props.auth.authUser.numberMode);
      }

      const senddata = {
        Action: 'change_reservation',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.state.res.data.Data[0].id,
          guestName: this.state.guestName,
          guestCity: this.state.guestCity,
          guestCountry: this.state.guestCountry,
          guestPhone: this.state.guestPhone,
          guestBirth: this.state.guestBirth,
          companyName: this.state.guestCompany,
          vat: this.state.guestVat,
          guestEmail: this.state.guestEmail,
          addEmail: this.state.addEmail,

          comment: this.state.comment,
          totalPrice: this.state.totalPrice,
          rooms: myRows,
          autoCancel: this.state.autoCancel,
          dueDate: x,
          freeCancel: x3,
          ignoreAnalytics: x2,
        },
      };

      axios.post(`https://secure.webbookingpro.com/api/pms.php`, senddata).then(res => {
        this.props.setState({ lastEvents: [], running2: false });
        if (this.props.doRefresh != null) this.props.doRefresh();
        this.refresh();

        /*this.setState(prevState => {
          return {
            changed: false,
            origGuestName: prevState.guestName,
            origGuestCity: prevState.guestCity,
            origGuestCountry: prevState.guestCountry,
            origGuestPhone: prevState.guestPhone,
            origGuestEmail: prevState.guestEmail,

            origTotalPrice: prevState.totalPrice,
            origComment: prevState.comment,
            origRows: prevState.rows,
          };
        });*/
      });
    }
  }

  refresh() {
    if (this.state.resId == '') return;
    //return;
    const token = localStorage.getItem('token');
    //var hotelCode = this.props.auth.authUser.hotels.filter(({ id }) => id == this.props.hotelId)[0].hotelCode;
    var hotelCodes = this.props.auth.authUser.hotels.filter(({ id }) => id == this.state.hotelId);
    var hotelCodes = this.props.auth.authUser.hotels.filter(({ id }) => id == this.state.hotelId);
    var hotelCode = null;
    if (hotelCodes.length > 0) hotelCode = hotelCodes[0].hotelCode;
    const senddata = {
      Action: 'get_reservation_details',
      token: token,
      Version: 1,
      Data: {
        HotelId: this.state.hotelId,
        AllGuest: 1,
        HotelCode: hotelCode,
        ReservationId: this.state.resId,
      },
    };
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    this.setState({ running2: true });
    console.log('pmsurl ');
    console.log(pmsUrl);
    if (pmsUrl == '') return;
    var mode = this.props.auth.authUser.clouduser;

    var nationalCurrency = '';
    if (mode == 1) nationalCurrency = this.props.auth.authUser.currencies.find(({ national }) => national === true).code;

    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      if (res.data != null && res.data.Data != null && res.data.Data[0] != null) {
        var renderData = [];
        this.setState({ invoiceId: res.data.Data[0].invoice_id });
        if (hotelCode != null) this.setState({ hotel_id: this.state.hotelId });
        else this.setState({ hotel_id: res.data.Data[0].hotel_id });
        this.setState({ refundDialog: false, comment: res.data.Data[0].Comment });
        this.setState({ paymentLink: '' });
        if (res.data.Data[0].Balance < 0)
          this.setState({ paymentAmount: myFormatPrice(-res.data.Data[0].Balance, this.props.auth.authUser.numberMode) });
        else this.setState({ paymentAmount: 0 });
        var sci = [];
        sci['en'] =
          'https://app.webbookingpro.com/pages/selfcheckin/wbp/' +
          res.data.Data[0].hotel_id +
          '/' +
          res.data.Data[0].id +
          '/?language=en';
        sci['hr'] =
          'https://app.webbookingpro.com/pages/selfcheckin/wbp/' +
          res.data.Data[0].hotel_id +
          '/' +
          res.data.Data[0].id +
          '/?language=hr';
        this.setState({ sci: sci });
        var mycolor = '',
          myfontcolor = '',
          mystatuscolor = '',
          mystatusfontcolor = '',
          myAutoCancel = false,
          mySetDueDate = false,
          mySetFreeCancel = false,
          myIgnoreAnalytics = false,
          myDueDate = null,
          myFreeCancel = null;

        if (mode == 0) {
          this.setState({ origComment: res.data.Data[0].Comment });
          this.setState({ extras: res.data.Data[0].extras });
          var status = res.data.Data[0].status;

          if (res.data.Data[0].autoCancel == '1') myAutoCancel = true;
          myDueDate = res.data.Data[0].dueDate;
          if (myDueDate != null && myDueDate != '0000-00-00 00:00:00') mySetDueDate = true;

          myFreeCancel = res.data.Data[0].freeCancel;
          if (myFreeCancel != null && myFreeCancel != '0000-00-00 00:00:00') mySetFreeCancel = true;

          myIgnoreAnalytics = res.data.Data[0].ignoreAnalytics == 1;

          var mystatus = '';
          if (status == 6) {
            mystatus = <IntlMessages id="bookings.cancelled" />;
            mystatuscolor = '#EF9A9A';
          }
          if (status == 2) {
            mystatus = <IntlMessages id="bookings.new" />;
            mystatuscolor = '#C5E1A5';
          }
          if (status < 2) {
            mystatus = <IntlMessages id="bookings.prebooking" />;
            mystatuscolor = '#d8a5e1';
          }
          if (res.data.Data[0].modifieddate != null && status == 2) {
            mystatus = <IntlMessages id="bookings.modified" />;
            mystatuscolor = '#FFF59D';
          }
          if ((status == 2 || status == 1) && mySetDueDate) {
            mystatus = <IntlMessages id="bookings.unconfirmed" />;
            mystatuscolor = '#8E8CD8';
          }
          if (status == 1 && mySetDueDate == false) {
            mystatuscolor = '#d8a5e1';
            mystatus = <IntlMessages id="bookings.unconfirmed2" />;
          }
          var mychannel = '';
          if (res.data.Data[0].name == null) mychannel = <IntlMessages id="bookings.direct" />;
          else mychannel = res.data.Data[0].name;

          if (res.data.Data[0].name != null && this.props.auth.authUser.expired == 1) {
            this.setState({ redirect: true });
          } else this.setState({ redirect: false });

          var totaladults = 0,
            totalkids = 0;
          var guestInfo = [];
          mycolor = res.data.Data[0].color;
          myfontcolor = res.data.Data[0].fontColor;
          var myAgencyId = -1;
          if (res.data.Data[0].isAgency == 1) myAgencyId = res.data.Data[0].created_by_admin_id;

          res.data.Data.forEach(function(item, index) {
            totaladults += parseInt(item.Adults);
            totalkids += parseInt(item.Children);
            var rguestInfo = item.guestInfo;
            rguestInfo.forEach(function(item2, index) {
              guestInfo.push(item2);
            });
          });
          var guestName = res.data.Data[0].Guests[0].FirstName + ' ' + res.data.Data[0].Guests[0].LastName;
          var guestPhone = res.data.Data[0].phone;
          var guestCity = res.data.Data[0].b_city;
          var guestCountry = res.data.Data[0].Country;
          var guestEmail = res.data.Data[0].Email;
          //          var addEmail = res.data.Data[0].Email;
          var totalPrice = res.data.Data[0].order_price;

          renderData = [
            { title: <IntlMessages id="bookings.id" />, desc: res.data.Data[0].booking_number, icon: '' },
            { title: <IntlMessages id="bookings.channel" />, desc: mychannel, icon: '' },
            {
              title: <IntlMessages id="res.arrival" />,
              desc: getMyDate2(res.data.Data[0].Checkin, this.props.auth.authUser.language),
              icon: '',
            },
            {
              title: <IntlMessages id="res.departure" />,
              desc: getMyDate2(res.data.Data[0].Checkout, this.props.auth.authUser.language),
              icon: '',
            },
            {
              title: <IntlMessages id="res.guest" />,
              desc: res.data.Data[0].Guests[0].FirstName + ' ' + res.data.Data[0].Guests[0].LastName,

              icon: '',
            },
            { title: <IntlMessages id="res.status" />, desc: <Chip label={mystatus} />, icon: '' },
            { title: <IntlMessages id="res.adults" />, desc: totaladults, icon: '' },
            { title: <IntlMessages id="res.children" />, desc: totalkids, icon: '' },
            {
              title: <IntlMessages id="bookings.dateCreated" />,
              desc: getMyDate3(res.data.Data[0].created_date, this.props.auth.authUser.language),
              icon: '',
            },
            {
              title: <IntlMessages id="bookings.dateModified" />,
              desc: getMyDate3(res.data.Data[0].modifieddate, this.props.auth.authUser.language),
              icon: '',
            },
            {
              title: <IntlMessages id="res.total" />,
              desc: res.data.Data[0].order_price + ' ' + res.data.Data[0].currency,
              icon: '',
            },
            {
              title: <IntlMessages id="res.guestTax" />,
              desc: res.data.Data[0].guest_tax + ' ' + res.data.Data[0].currency,
              icon: '',
            },
            {
              title: <IntlMessages id="res.extras" />,
              desc: res.data.Data[0].extras_fee + ' ' + res.data.Data[0].currency,
              icon: '',
            },
            {
              title: '',
              desc: '',
              icon: '',
            },
            {
              title: <IntlMessages id="res.paymentinfo" />,
              desc: parse(res.data.Data[0].payment_info),
              icon: '',
            },
          ];
          var myRows = res.data.Data;
          for (var i = 0; i < myRows.length; i++) {
            myRows[i].priceo = myRows[i].price;
            myRows[i].price = myFormatPrice(myRows[i].price, this.props.auth.authUser.numberMode);
          }
          var rows = myRows;
        }
        if (mode == 1) {
          var total = '';
          if (res.data.Data[0].TotalPriceCurr != 0 && nationalCurrency != res.data.Data[0].Currency)
            total = res.data.Data[0].TotalPriceCurr + ' ' + res.data.Data[0].Currency + '<BR/>';
          if (res.data.Data[0].TotalPrice != 0) total += res.data.Data[0].TotalPrice + ' ' + nationalCurrency;
          var mystatus = <IntlMessages id="status.arriving" />;
          if (res.data.Data[0].Status == 'checkedin') mystatus = <IntlMessages id="status.checkedin" />;
          if (res.data.Data[0].Status == 'checkedout') mystatus = <IntlMessages id="status.checkedout" />;

          var renderData2 = [
            {
              title: <IntlMessages id="viewClient.name" />,
              desc: res.data.Data[0].Guests[0].FirstName + ' ' + res.data.Data[0].Guests[0].LastName,
              icon: '',
            },
            { title: '', desc: '', icon: '' },
            { title: <IntlMessages id="res.city" />, desc: res.data.Data[0].City, icon: '' },
            { title: <IntlMessages id="viewClient.country" />, desc: res.data.Data[0].Country, icon: '' },
            {
              title: <IntlMessages id="viewClient.phone" />,
              desc: <a href={'tel:' + res.data.Data[0].Phone}>{res.data.Data[0].Phone}</a>,
              icon: '',
            },
            {
              title: <IntlMessages id="viewClient.email" />,
              desc: <a href={'mailto:' + res.data.Data[0].Email}>{res.data.Data[0].Email}</a>,
              icon: '',
            },
          ];

          var mystatus2 = <Chip label={mystatus} />;
          var serviceName = this.props.auth.authUser.services.find(({ ID }) => ID == res.data.Data[0].ServiceId).Name;
          var price = '';
          if (res.data.Data[0].TotalPrice != '')
            price += formatPrice(res.data.Data[0].TotalPrice, 'hr') + ' ' + nationalCurrency;
          if (res.data.Data[0].TotalPriceCurr != '' && res.data.Data[0].Currency != nationalCurrency) {
            if (price != '') price += ', ';
            price += formatPrice(res.data.Data[0].TotalPriceCurr, 'hr') + ' ' + res.data.Data[0].Currency;
          }

          renderData = [
            { title: <IntlMessages id="res.id" />, desc: res.data.Data[0].BookingId, icon: '' },
            { title: '', desc: '', icon: '' },
            {
              title: <IntlMessages id="res.arrival" />,
              desc: getMyDate2(res.data.Data[0].Checkin, this.props.auth.authUser.language),
              icon: '',
            },
            {
              title: <IntlMessages id="res.departure" />,
              desc: getMyDate2(res.data.Data[0].Checkout, this.props.auth.authUser.language),
              icon: '',
            },
            {
              title: <IntlMessages id="res.guest" />,
              desc: res.data.Data[0].Guests[0].FirstName + ' ' + res.data.Data[0].Guests[0].LastName,
              icon: '',
            },
            { title: <IntlMessages id="res.status" />, desc: mystatus2, icon: '' },
            { title: <IntlMessages id="res.adults" />, desc: res.data.Data[0].Adults, icon: '' },
            { title: <IntlMessages id="res.children" />, desc: res.data.Data[0].Children, icon: '' },
            { title: <IntlMessages id="res.service" />, desc: serviceName, icon: '' },
            { title: <IntlMessages id="res.guestPrice" />, desc: price, icon: '' },
          ];
          //if (total != '') renderData.push({ title: <IntlMessages id="res.total" />, desc: parse(total), icon: '' });
          var guests = res.data.Data[0].Guests;

          var rows = [];
          if (res.data.Data[0].Status != 'arrival')
            guests.forEach(function(item, index) {
              rows.push(createData(item.FirstName + ' ' + item.LastName, item.BirthDate, item.Sex, item.City, item.Country));
            });
        }
        var rows2 = JSON.parse(JSON.stringify(rows));
        var customPrepaymentMode = -1,
          customPayment = '',
          customPayment2 = 100;
        if (res.data.Data[0].prepaymentAmount != -1) {
          customPrepaymentMode = 0;
          customPayment = res.data.Data[0].prepaymentAmount;
        }
        if (res.data.Data[0].prepaymentPercentage != -1) {
          customPrepaymentMode = 1;
          customPayment2 = parseInt(res.data.Data[0].prepaymentPercentage);
        }

        this.setState({
          guestInfo: guestInfo,
          /*  guestName: guestName,
          guestCity: guestCity,
          guestCountry: guestCountry,
          guestPhone: guestPhone,
          guestEmail: guestEmail,


          origGuestName: guestName,
          origGuestEmail: guestEmail,
          origGuestPhone: guestPhone,
          origGuestCity: guestCity,
          origGuestCountry: guestCountry,*/

          data: renderData,
          data2: renderData2,
          rows: rows,
          origRows: rows2,
          res: res,
          totalKids: totalkids,
          paymentId: res.data.Data[0].payment_type,
          customPrepaymentMode: customPrepaymentMode,
          customPrepayment: customPayment,
          customPrepayment2: customPayment2,
          totalAdults: totaladults,
          totalPrice: totalPrice,
          autoCancel: myAutoCancel,
          setDueDate: mySetDueDate,
          setFreeCancel: mySetFreeCancel,
          freeCancel: myFreeCancel,
          ignoreAnalytics: myIgnoreAnalytics,
          dueDate: myDueDate,
          addEmail: res.data.Data[0].addEmail,
          changed: false,
          agencyId: myAgencyId,
          running2: false,
          origTotalPrice: totalPrice,
          channel: mychannel,
          color: mycolor,
          statuscolor: mystatuscolor,
          statusfontcolor: mystatusfontcolor,
          fontcolor: myfontcolor,
          status: mystatus,
        });
      } else this.props.setState({ resDetailsVisible: false });
    });

    if (mode == 0) {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'getClient',
        token: token,
        Version: 1,
        Data: {
          ReservationId: this.state.resId,
        },
      };
      //    console.log('pms');
      var pmsUrl = this.props.auth.authUser.pmsUrl;
      //      console.log(pmsUrl);
      if (pmsUrl == '') return;
      var mode = this.props.auth.authUser.clouduser;
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (res.data.Data != null) {
          var x = res.data.Data.birthDate;
          if (x == '0000-00-00') x = '';
          this.setState({
            guestName: res.data.Data.firstName + ' ' + res.data.Data.lastName,
            guestBirthDate: res.data.Data.birthDate,
            guestAddress1: res.data.Data.address1,
            guestAddress2: res.data.Data.address2,
            guestCity: res.data.Data.city,
            guestCountry: res.data.Data.country,
            guestPhone: res.data.Data.phone,
            guestBirth: x,
            guestCompany: res.data.Data.company,
            guestVat: res.data.Data.vat,
            guestFax: res.data.Data.fax,
            guestEmail: res.data.Data.email,
          });
        }
      });

      const senddata2 = {
        Action: 'getInvoices',
        token: token,
        Version: 1,
        Data: {
          reservationId: this.state.resId,
        },
      };
      //    console.log('pms');
      var pmsUrl = this.props.auth.authUser.pmsUrl;
      //      console.log(pmsUrl);
      if (pmsUrl == '') return;
      var mode = this.props.auth.authUser.clouduser;
      axios.post(pmsUrl, senddata2).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (res.data.Data != null) {
          this.setState({
            invoices: res.data.Data,
          });
        }
      });
    }

    const senddata2 = {
      Action: 'getActivities',
      token: token,
      Version: 1,
      Data: {
        reservationId: this.state.resId,
      },
    };
    //    console.log('pms');
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    //      console.log(pmsUrl);
    if (pmsUrl == '') return;
    var mode = this.props.auth.authUser.clouduser;
    axios.post(pmsUrl, senddata2).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      if (res.data.Data != null) {
        this.setState({
          activities: res.data.Data,
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.resId !== this.props.resId || prevProps.hotelId !== this.props.hotelId) {
      this.setState({ resId: this.props.resId, hotelId: this.props.hotelId }, () => {
        this.refresh();
      });
      //this.refresh();
    }
  }

  handleChange2(name, value, index = -1) {
    if (value == null) return;
    if (index != -1) {
      this.setState(prevState => {
        const guestInfos = [...prevState.guestInfo];
        if (name == 'BirthCountry') {
          if (guestInfos[index]['Citizenship'] == '') guestInfos[index]['Citizenship'] = value;
          if (guestInfos[index]['Country'] == '') guestInfos[index]['Country'] = value;
        }
        if (name == 'Country') {
          if (guestInfos[index]['Citizenship'] == '') guestInfos[index]['Citizenship'] = value;
          if (guestInfos[index]['BirthCountry'] == '') guestInfos[index]['BirthCountry'] = value;
        }
        if (name == 'CitizenShip') {
          if (guestInfos[index]['Country'] == '') guestInfos[index]['Country'] = value;
          if (guestInfos[index]['BirthCountry'] == '') guestInfos[index]['BirthCountry'] = value;
        }
        guestInfos[index][name] = value;
        /*if (name == 'FirstName') .FirstName = value;
        if (name == 'LastName') guestInfos[index].LastName = value;
        if (name == 'RoomId') guestInfos[index].RoomId = value;
        if (name == 'Sex') guestInfos[index].Sex = value;
        if (name == 'BirthDate') guestInfos[index].BirthDate = value;
        if (name == 'idType') guestInfos[index].idType = value;
        if (name == 'idNumber') guestInfos[index].idNumber = value;
        if (name == 'City') guestInfos[index].City = value;
        if (name == 'Country') guestInfos[index].Country = value;
        if (name == 'Citizenship') guestInfos[index].Citizenship = value;*/
        return { guestInfo: guestInfos };
      });
    }
  }

  handleChange(name, value, index = -1, level = 0) {
    var userRole = this.props.auth.authUser.role;
    if (name == 'voucherNumber') {
      this.setState({ [name]: value }, () => {
        //   this.updateRooms();
      });
      return;
    }
    if (name == 'file') {
      console.log(value);
      let reader = new FileReader();

      // Convert the file to base64 text

      reader.onload = function() {
        var b64 = reader.result.replace(/^data:.+;base64,/, '');
        this.setState({ fileb64: b64, filesize: value.size, filename: value.name, filetype: value.type });
      }.bind(this);
      reader.readAsDataURL(value);

      return;
    }

    if (level == 0 && [5, 13].includes(userRole)) return;
    if (level == 1 && [5, 13, 11, 12].includes(userRole)) return;
    if (index != -1) {
      this.setState(prevState => {
        const rows = [...prevState.rows];
        rows[index][name] = value;
        return { rows: rows, changed: true };
      });
    } else
      this.setState({ [name]: value, changed: true }, () => {
        //   this.updateRooms();
      });
  }

  componentDidMount() {}

  handleClose() {
    this.props.setState({ resDetailsVisible: false });
    //  setOpen(false);
  }

  handleCCClose() {
    this.setState({ viewCCVisible: false, myanchorEl: null });
    //  setOpen(false);
  }

  render() {
    const { classes } = this.props;
    var mode = this.props.auth.authUser.clouduser;
    var defaultCurrency = this.props.auth.authUser.currencies[0].code;
    const { intl } = this.props;
    var userRole = this.props.auth.authUser.role;

    var guestEngine = 0;
    if (this.props.auth.authUser.hotels.find(({ id }) => id === this.state.hotel_id) != null)
      guestEngine = this.props.auth.authUser.hotels.find(({ id }) => id === this.state.hotel_id).engine;
    if (guestEngine == 0) {
      countries = countriesEN;
      if (this.props.auth.authUser.language == 'sr') var countries = countriesEN;
      if (this.props.auth.authUser.language == 'hr') var countries = countriesHR;
    } else {
      var countries = countriesBIH;
    }

    var disableCheckin = false;
    var disableCheckout = false;
    var userRole = this.props.auth.authUser.role;
    var today = new Date();
    var yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    if (this.state.res != null)
      if (this.state.res.data != null)
        if (this.state.res.data.Data[0] != null) {
          if (this.state.res.data.Data[0].Checkin < getMyDate(yesterday)) disableCheckin = true;
          if (this.state.res.data.Data[0].Checkin > getMyDate(today)) disableCheckin = true;

          //if (this.state.res.data.Data[0].Checkout < getMyDate(yesterday) && this.state.res.data) disableCheckin = true;
          if (this.state.res.data.Data[0].Checkout > getMyDate(today)) disableCheckout = true;
        }
    var booking_number = '';
    var crsId = '';
    var pmsId = '';
    var voucher = '';
    var blockCode = '';

    var usedCurrency = '';
    if (this.state.res != null) {
      booking_number = this.state.res.data.Data[0].booking_number;
      if (this.state.channel == 'hotelBeds') {
        if (booking_number.indexOf('_') > 0) booking_number = booking_number.substring(0, booking_number.indexOf('_'));
      }
      crsId = 'FT' + this.state.res.data.Data[0].id;
      pmsId = this.state.res.data.Data[0].pmsID;
      blockCode = this.state.res.data.Data[0].blockCode;
      voucher = this.state.res.data.Data[0].voucher;
      usedCurrency = this.state.res.data.Data[0].currency;
    }

    var documents = [
      { id: '1', name: intl.formatMessage({ id: 'selfcheckin.d1' }) },
      { id: '2', name: intl.formatMessage({ id: 'selfcheckin.d2' }) },
      { id: '3', name: intl.formatMessage({ id: 'selfcheckin.d3' }) },
      { id: '4', name: intl.formatMessage({ id: 'selfcheckin.d4' }) },
      { id: '5', name: intl.formatMessage({ id: 'selfcheckin.d5' }) },
      { id: '6', name: intl.formatMessage({ id: 'selfcheckin.d6' }) },
    ];

    return (
      <div>
        {this.state.redirect && <Redirect to="/pages/upgrade" />}
        <Dialog fullScreen open={this.props.open} onClose={this.handleClose} hideBackdrop>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title}>
                {this.props.resTitle}
              </Typography>
            </Toolbar>
          </AppBar>
          {this.state.running2 == true && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                left: 0,
                top: 0,
                position: 'fixed',
                bottom: 0,
                right: 0,
                alignItems: 'center',
              }}>
              <CircularProgress color="inherit" />
            </div>
          )}
          {this.state.running2 == false && (
            <>
              <Box className={classes.boxTop}>
                {mode == 0 && (
                  <Box className={classes.boxTop2}>
                    <Grid container>
                      <Grid xs={12} sm={12} xl={12}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="res.guest" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              <TextField
                                id="guestName"
                                value={this.state.guestName}
                                fullWidth
                                InputProps={{
                                  readOnly: true,
                                }}
                                onChange={event => this.handleChange('guestName', event.target.value, -1, 0)}
                              />
                              {[10, 11, 15, 12].includes(userRole) && (
                                <Button
                                  variant="contained"
                                  size="small"
                                  color="primary"
                                  className={classes.myButton}
                                  onClick={e => this.handleClick(e, 'findClient')}>
                                  <IntlMessages id="findClient" />
                                </Button>
                              )}
                              {[10, 11, 12, 16, 17].includes(userRole) && (
                                <Button
                                  variant="contained"
                                  size="small"
                                  color="primary"
                                  className={classes.myButton}
                                  onClick={e => this.handleClick(e, 'newClient')}>
                                  <IntlMessages id="newClient" />
                                </Button>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid xs={12} sm={1} xl={1}>
                        {' '}
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="res.status" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              <Chip
                                label={this.state.status}
                                style={{ borderRadius: 2, backgroundColor: this.state.statuscolor }}
                              />
                              {this.state.rows[0] != null && this.state.rows[0].checkInStatus == '1' && (
                                <Chip
                                  label=<IntlMessages id="status.checkedin" />
                                  style={{ borderRadius: 2, backgroundColor: '#40FF40' }}
                                />
                              )}
                              {this.state.rows[0] != null && this.state.rows[0].checkInStatus == '2' && (
                                <Chip
                                  label=<IntlMessages id="status.checkedout" />
                                  style={{ borderRadius: 2, backgroundColor: '#FF4D4D' }}
                                />
                              )}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid xs={12} sm={2} xl={2}>
                        {' '}
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="res.arrival" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              {this.state.res != null &&
                                getMyDate2(this.state.res.data.Data[0].Checkin, this.props.auth.authUser.language)}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid xs={12} sm={2} xl={2}>
                        {' '}
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="res.departure" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              {this.state.res != null &&
                                getMyDate2(this.state.res.data.Data[0].Checkout, this.props.auth.authUser.language)}
                            </Box>
                            <Box fontSize={12} color="text.secondary">
                              {this.state.res != null && this.state.res.data.Data[0].nights + ' '}
                              <IntlMessages id="bookings.nights" />
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={2} xl={2}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="bookings.id" />
                            </Box>
                            <Box className={classes.columnRoot}>{booking_number}</Box>
                            {crsId != '' && (
                              <Box fontSize={12} color="text.secondary">
                                CRS ID: {crsId}
                              </Box>
                            )}
                            {pmsId != '' && (
                              <Box fontSize={12} color="text.secondary">
                                PMS ID: {pmsId}
                              </Box>
                            )}
                            {voucher != '' && (
                              <Box fontSize={12} color="text.secondary">
                                Voucher ID: {voucher}
                              </Box>
                            )}
                            {blockCode != '' && (
                              <Box fontSize={12} color="text.secondary">
                                Block Code: {blockCode}
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </Grid>
                      <Grid xs={12} sm={2} xl={2}>
                        {' '}
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="bookings.channel" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              <Chip
                                label={this.state.channel}
                                style={{ borderRadius: 2, backgroundColor: this.state.color, color: this.state.fontcolor }}
                              />
                            </Box>
                            {this.state.res.data.Data[0].isAgency == 1 &&
                              this.state.res.data.Data[0].created_by_admin_id != 0 &&
                              [10, 11, 12, 16, 17].includes(userRole) &&
                              this.state.readOnly == false && (
                                <Box className={classes.columnRoot}>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    className={classes.myButton}
                                    onClick={e => this.handleClick(e, 'changeTA')}>
                                    <IntlMessages id="findAgency" />
                                  </Button>
                                </Box>
                              )}
                          </Box>
                        </Box>
                      </Grid>
                      <Grid xs={12} sm={1} xl={1}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="res.total" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              {myFormatPrice(this.state.totalPrice, this.props.auth.authUser.numberMode)}{' '}
                              {this.state.res != null && this.state.res.data.Data[0].currency}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid xs={12} sm={2} xl={2}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="balance" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              {this.state.res != null && (
                                <>
                                  {myFormatPrice(this.state.res.data.Data[0].Balance, this.props.auth.authUser.numberMode)}{' '}
                                  {this.state.res.data.Data[0].currency}
                                  <br />
                                  {this.state.res.data.Data[0].AllFolios == 0 && <IntlMessages id="noFoliosCreated" />}
                                  {this.state.res.data.Data[0].AllFolios > 0 && this.state.res.data.Data[0].OpenFolios > 0 && (
                                    <>
                                      {this.state.res.data.Data[0].OpenFolios} <IntlMessages id="foliosOpened" />
                                    </>
                                  )}
                                  {this.state.res.data.Data[0].AllFolios > 0 &&
                                    this.state.res.data.Data[0].OpenFolios == 0 && <IntlMessages id="allFoliosClosed" />}
                                </>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                )}

                <AppBar position="static">
                  <Tabs
                    value={this.state.tabroom}
                    onChange={this.handleTabChange}
                    aria-label="simple tabs example"
                    scrollButtons="auto"
                    variant="scrollable"
                    indicatorColor="primary">
                    <Tab label=<IntlMessages id="resdetail.general" /> {...a11yProps(0)} />
                    <Tab label=<IntlMessages disabled={mode == 2} id="resdetail.client" /> {...a11yProps(1)} />
                    <Tab
                      disabled={
                        !(mode != 2 && [10, 12, 16, 17].includes(userRole)) ||
                        (this.state.rows[0] != null && this.state.rows[0].status < 2)
                      }
                      label=<IntlMessages id="resdetail.guests" />
                      {...a11yProps(2)}
                    />

                    <Tab
                      disabled={!([10, 12, 20, 16, 17].includes(userRole) && mode == 0)}
                      label=<IntlMessages id="resdetail.extras" />
                      {...a11yProps(3)}
                    />

                    <Tab
                      disabled={
                        !([10, 12, 16, 17].includes(userRole) && mode == 0) ||
                        (this.state.rows[0] != null && this.state.rows[0].status < 2)
                      }
                      label="FOLIOS"
                      {...a11yProps(5)}
                    />

                    <Tab
                      disabled={!(mode == 0) || (this.state.rows[0] != null && this.state.rows[0].status == 0)}
                      label=<IntlMessages id="resdetail.invoices" />
                      {...a11yProps(4)}
                    />

                    <Tab
                      disabled={!([10, 19, 12, 16, 17].includes(userRole) && mode == 0)}
                      label=<IntlMessages id="pages.messages" />
                      {...a11yProps(7)}
                    />

                    <Tab label=<IntlMessages disabled={!(mode == 0)} id="resdetail.log" /> {...a11yProps(6)} />
                    {this.state.rows[0] != null && this.state.rows[0].masterId != 0 && (
                      <Tab label=<IntlMessages id="pages.linkedReservations" /> {...a11yProps(8)} />
                    )}
                  </Tabs>
                </AppBar>
              </Box>

              <TabPanel value={this.state.tabroom} index={0}>
                <Box className={classes.boxTop}>
                  {mode == 0 && (
                    <Grid container>
                      <Grid xs={12} sm={6} xl={6}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="res.adults" />
                            </Box>
                            <Box className={classes.columnRoot}>{this.state.totalAdults}</Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid xs={12} sm={6} xl={6}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="res.children" />
                            </Box>
                            <Box className={classes.columnRoot}>{this.state.totalKids}</Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid xs={12} sm={6} xl={6}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="bookings.dateCreated" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              {this.state.res != null &&
                                getMyDate3(this.state.res.data.Data[0].created_date, this.props.auth.authUser.language)}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid xs={12} sm={6} xl={6}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="bookings.dateModified" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              {this.state.res != null &&
                                getMyDate3(this.state.res.data.Data[0].modifieddate, this.props.auth.authUser.language)}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid xs={12} sm={6} xl={6}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="res.guestTax" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              {this.state.res != null &&
                                myFormatPrice(this.state.res.data.Data[0].guest_tax, this.props.auth.authUser.numberMode) +
                                  ' ' +
                                  this.state.res.data.Data[0].currency}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid xs={12} sm={6} xl={6}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="res.extras" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              {this.state.res != null &&
                                myFormatPrice(this.state.res.data.Data[0].extras_fee, this.props.auth.authUser.numberMode) +
                                  ' ' +
                                  this.state.res.data.Data[0].currency}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid xs={12} sm={6} xl={6}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary"></Box>
                            <Box className={classes.columnRoot}></Box>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid xs={12} sm={6} xl={6}>
                        <Box display="flex" alignItems="center">
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              <IntlMessages id="res.paymentinfo" />
                            </Box>
                            <Box className={classes.columnRoot}>
                              {this.state.res != null && parse(this.state.res.data.Data[0].payment_info)}
                              {this.state.res != null && this.state.res.data.Data[0].is_nonref == 1 && (
                                <Chip
                                  label="non-refundable"
                                  style={{ borderRadius: 2, backgroundColor: '#7732a8', color: '#ffffff' }}
                                />
                              )}
                              {this.state.res != null && this.state.res.data.Data[0].prePayment != 0 && (
                                <>
                                  <IntlMessages id="requiredPrepayment" />
                                  {myFormatPrice(
                                    this.state.res.data.Data[0].prePayment,
                                    this.props.auth.authUser.numberMode,
                                  ) +
                                    ' ' +
                                    this.state.res.data.Data[0].currency}
                                </>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                  {mode == 1 && (
                    <CmtGridView
                      data={this.state.data}
                      renderRow={this.renderRow}
                      itemPadding={10}
                      responsive={{
                        xs: 1,
                        sm: 2,
                        md: 2,
                        lg: 2,
                        xl: 3,
                      }}
                      renderRow={(item, index) => (
                        <Box display="flex" alignItems="center" key={index}>
                          {item.icon}
                          <Box>
                            <Box fontSize={12} color="text.secondary">
                              {item.title}
                            </Box>
                            <Box className={classes.columnRoot}>{item.desc}</Box>
                          </Box>
                        </Box>
                      )}
                    />
                  )}
                </Box>
                {mode == 1 && [10, 11, 12, 16, 17].includes(userRole) && (
                  <>
                    <Box>
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.myButton}
                        onClick={e => this.handleClick(e, 'cancelReservation')}>
                        <IntlMessages id="bookings.cancelReservation" />
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.myButton}
                        onClick={e => this.handleClick(e, 'noShow')}>
                        <IntlMessages id="bookings.noShow" />
                      </Button>
                    </Box>
                  </>
                )}
                {mode == 0 && (
                  <>
                    {[10, 11, 12, 20, 16, 17].includes(userRole) && (
                      <Box>
                        {[10, 11, 12, 16, 17].includes(userRole) &&
                          this.state.rows[0] != null &&
                          this.state.rows[0].status < 2 && (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.myButton}
                              onClick={e => this.handleClick(e, 'confirm')}>
                              <IntlMessages id="confirm" />
                            </Button>
                          )}

                        {this.state.rows[0] != null &&
                          this.state.rows[0].checkInStatus == '0' &&
                          [10, 11, 12, 16, 17].includes(userRole) &&
                          this.state.rows[0].status == 2 && (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.myButton}
                              disabled={disableCheckin}
                              onClick={e => this.handleClick(e, 'tabCheckIn')}>
                              <IntlMessages id="doCheckIn" />
                            </Button>
                          )}

                        {this.state.rows[0] != null &&
                          [10, 11, 12, 16, 17].includes(userRole) &&
                          this.state.rows[0].confirmed == 1 && (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.myButton}
                              onClick={e => this.handleClick(e, 'unconfirmPMS')}>
                              <IntlMessages id="unconfirmPMS" />
                            </Button>
                          )}

                        {this.state.rows[0] != null &&
                          this.state.rows[0].externalUrl != '' &&
                          [10, 11, 12, 16, 17].includes(userRole) &&
                          this.state.rows[0].externalUrl != null && (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.myButton}
                              onClick={e => this.handleClick(e, 'openExtranet')}>
                              <IntlMessages id="openExtranet" />
                            </Button>
                          )}

                        {this.state.rows[0] != null &&
                          this.state.rows[0].checkInStatus == '1' &&
                          [10, 11, 12, 16, 17].includes(userRole) && (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.myButton}
                              disabled={disableCheckout}
                              onClick={e => this.handleClick(e, 'doCheckOut')}>
                              <IntlMessages id="doCheckOut" />
                            </Button>
                          )}
                        {this.state.rows[0] != null &&
                          this.state.rows[0].canCC == '' &&
                          [10, 11, 12, 16, 17].includes(userRole) && (
                            <>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.myButton}
                                onClick={e => this.handleClick(e, 'addCC')}>
                                <IntlMessages id="addCC" />
                              </Button>
                            </>
                          )}

                        {this.state.rows[0] != null &&
                          this.state.rows[0].canCC != '' &&
                          [10, 11, 12, 16, 17].includes(userRole) && (
                            <>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.myButton}
                                onClick={e => this.handleClick(e, 'viewCC')}>
                                <IntlMessages id="viewCC" />
                              </Button>

                              <Popover
                                open={this.state.viewCCVisible2}
                                anchorEl={this.state.myanchorEl2}
                                onClose={this.handleCCClose}
                                anchorOrigin={{
                                  vertical: 'bottom',
                                  horizontal: 'left',
                                }}>
                                <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>
                              </Popover>
                            </>
                          )}
                        {this.state.invoiceId != null && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.myButton}
                            onClick={e => this.handleClick(e, 'viewInvoice')}>
                            <IntlMessages id="bookings.viewInvoice" />
                          </Button>
                        )}

                        {this.state.rows[0] != null &&
                          this.state.rows[0].canCancel == '1' &&
                          this.state.rows[0] != null &&
                          this.state.rows[0].status != 6 && (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.myButton}
                              onClick={e => this.handleClick(e, 'cancelReservation')}>
                              {this.state.rows[0] != null && this.state.rows[0].status == 2 && (
                                <IntlMessages id="bookings.cancelReservation" />
                              )}
                              {this.state.rows[0] != null && this.state.rows[0].status < 2 && (
                                <IntlMessages id="bookings.cancelOffer" />
                              )}
                            </Button>
                          )}
                        {this.state.rows[0] != null && this.state.rows[0] != null && this.state.rows[0].status == 2 && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.myButton}
                            onClick={e => this.handleClick(e, 'noShow')}>
                            <IntlMessages id="bookings.noShow" />
                          </Button>
                        )}
                        {[10, 11, 12, 16, 17].includes(userRole) &&
                          this.state.rows[0] != null &&
                          this.state.rows[0].canUnCancel == '1' && (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.myButton}
                              onClick={e => this.handleClick(e, 'unCancelReservation')}>
                              <IntlMessages id="unCancelReservation" />
                            </Button>
                          )}
                        <br />
                        {this.state.rows[0] != null &&
                          this.state.rows[0].canCC == '' &&
                          [10, 11, 12, 20, 16, 17].includes(userRole) && (
                            <>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.myButton}
                                onClick={e => this.setState({ addVoucherVisible: true })}>
                                <IntlMessages id="addVoucher" />
                              </Button>
                            </>
                          )}
                        {this.state.rows[0] != null &&
                          this.state.rows[0].canCC == '' &&
                          [10, 11, 12, 20, 16, 17].includes(userRole) && (
                            <>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.myButton}
                                onClick={e =>
                                  this.setState({
                                    voucherNumber: this.state.res.data.Data[0].voucher,
                                    addVoucherVisible2: true,
                                  })
                                }>
                                <IntlMessages id="modifyVoucher" />
                              </Button>
                            </>
                          )}

                        {this.state.rows[0] != null &&
                          this.state.rows[0].voucherFile != '' &&
                          [10, 11, 12, 16, 17, 20].includes(userRole) && (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.myButton}
                              onClick={e => this.handleClick(e, 'downloadVoucher')}>
                              <IntlMessages id="downloadVoucher" />
                            </Button>
                          )}

                        {this.state.rows[0] != null &&
                          this.state.rows[0].canCC == '' &&
                          [10, 11, 12, 20, 16, 17].includes(userRole) && (
                            <>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.myButton}
                                onClick={e => this.setState({ addPaymentProof: true })}>
                                <IntlMessages id="addPaymentProof" />
                              </Button>
                            </>
                          )}
                        {this.state.rows[0] != null &&
                          this.state.rows[0].paymentProof != '' &&
                          [10, 11, 12, 16, 17, 20].includes(userRole) && (
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.myButton}
                              onClick={e => this.handleClick(e, 'downloadPaymentProof')}>
                              <IntlMessages id="downloadPaymentProof" />
                            </Button>
                          )}

                        {this.state.changed && (
                          <Box className={classes.boxClass}>
                            <Button
                              variant="contained"
                              color="secondary"
                              className={classes.myButton}
                              onClick={e => this.runAction(e, 'cancel')}
                              startIcon={<Cancel />}>
                              <IntlMessages id="cockpit.cancel" />
                            </Button>
                            <Button
                              variant="contained"
                              color="secondary"
                              className={classes.myButton}
                              onClick={e => this.runAction(e, 'save')}
                              startIcon={<CloudDone />}>
                              <IntlMessages id="cockpit.save" />
                            </Button>
                          </Box>
                        )}
                      </Box>
                    )}
                    {mode == 0 && [10, 11, 12, 16, 17].includes(userRole) && (
                      <>
                        <Box className={classes.cardContentInner}>
                          <FormControlLabel
                            value="bottom"
                            control={
                              <Checkbox
                                color="primary"
                                checked={this.state.setDueDate}
                                onChange={event => this.handleChange('setDueDate', event.target.checked, -1, 0)}
                              />
                            }
                            label=<IntlMessages id="res.setDueDate" />
                            labelPlacement="right"
                          />
                          {this.state.setDueDate && (
                            <DatePicker
                              label=<IntlMessages id="res.setDueDate" />
                              value={this.state.dueDate}
                              ampm={false}
                              closeOnSelect={true}
                              maxDate={this.state.rows.length > 0 ? this.state.rows[0].checkin : null}
                              disablePast={true}
                              minutesStep={60}
                              onChange={newValue => this.handleChange('dueDate', newValue, -1, 0)}
                            />
                          )}
                          {this.state.setDueDate && (
                            <FormControlLabel
                              value="bottom"
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={this.state.autoCancel}
                                  onChange={event => this.handleChange('autoCancel', event.target.checked, -1, 0)}
                                />
                              }
                              label=<IntlMessages id="res.autoCancel" />
                              labelPlacement="right"
                            />
                          )}
                        </Box>
                        <Box className={classes.cardContentInner}>
                          <FormControlLabel
                            value="bottom"
                            control={
                              <Checkbox
                                color="primary"
                                checked={this.state.setFreeCancel}
                                onChange={event => this.handleChange('setFreeCancel', event.target.checked, -1, 0)}
                              />
                            }
                            label=<IntlMessages id="res.setFreeCancel" />
                            labelPlacement="right"
                          />
                          {this.state.setFreeCancel && (
                            <DatePicker
                              label=<IntlMessages id="freeCancellation" />
                              value={this.state.freeCancel}
                              ampm={false}
                              closeOnSelect={true}
                              disablePast={true}
                              maxDate={this.state.rows.length > 0 ? this.state.rows[0].checkin : null}
                              minutesStep={60}
                              onChange={newValue => this.handleChange('freeCancel', newValue, -1, 0)}
                            />
                          )}
                        </Box>

                        <Box className={classes.cardContentInner}>
                          <FormControlLabel
                            value="bottom"
                            control={
                              <Checkbox
                                color="primary"
                                checked={this.state.ignoreAnalytics}
                                onChange={event => this.handleChange('ignoreAnalytics', event.target.checked, -1, 0)}
                              />
                            }
                            label="Ignore reservation in Analytics"
                            labelPlacement="right"
                          />
                        </Box>
                      </>
                    )}
                    <Box>
                      <TableContainer component={Paper} className={classes.root}>
                        <Table className={classes.table} size="small" aria-label="a dense table">
                          <TableHead>
                            <TableRow>
                              <TableCell>
                                <IntlMessages id="#" />
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell align="left">
                                <IntlMessages id="quickres.roomType" />
                              </TableCell>
                              <TableCell align="left">
                                <IntlMessages id="bookings.roomNumber" />
                              </TableCell>
                              <TableCell align="left">
                                <IntlMessages id="res.arrival" />
                              </TableCell>
                              <TableCell align="left">
                                <IntlMessages id="res.departure" />
                              </TableCell>
                              <TableCell align="left">
                                <IntlMessages id="res.rooms" />
                              </TableCell>
                              <TableCell align="left">
                                <IntlMessages id="res.adults" />
                              </TableCell>
                              <TableCell align="left">
                                <IntlMessages id="res.children" />
                              </TableCell>
                              <TableCell align="left">
                                <IntlMessages id="quickres.rate" />
                              </TableCell>
                              <TableCell align="left">
                                <IntlMessages id="res.mealPlans" />
                              </TableCell>
                              <TableCell align="left">
                                <IntlMessages id="res.roomPrice" />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.rows.map((row, index) => (
                              <>
                                <TableRow key={row.id}>
                                  <TableCell component="th" scope="row">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell component="th" scope="row">
                                    {this.state.readOnly == false && (
                                      <IconButton
                                        onClick={e => this.handleClick(e, 'deletereservationrooom', row)}
                                        disabled={this.state.rows.length < 2}>
                                        <DeleteIcon />
                                      </IconButton>
                                    )}
                                  </TableCell>

                                  <TableCell>
                                    {this.props.auth.authUser.hotels.length > 1 &&
                                      this.props.auth.authUser.hotels.filter(
                                        function(itemx) {
                                          return itemx.id == this.state.hotel_id;
                                        }.bind(this),
                                      )[0].name}
                                    {this.props.auth.authUser.hotels.length > 1 && <br />}
                                    <TextField
                                      id="roomName"
                                      value={row.room_id}
                                      disabled
                                      onChange={event => this.handleChange('room_id', event.target.value, index, 1)}
                                      select>
                                      {this.props.auth.authUser.roomtypes
                                        .filter(
                                          function(itemx) {
                                            return itemx.hotelid == this.state.hotel_id;
                                          }.bind(this),
                                        )
                                        .map((t, idx) => (
                                          <MenuItem value={t.ID}>{t.Name}</MenuItem>
                                        ))}
                                    </TextField>
                                  </TableCell>
                                  <TableCell>
                                    {this.props.auth.authUser.rooms.filter(
                                      function(itemx) {
                                        return itemx.hotelid == this.state.hotel_id && itemx.rtId == row.room_id;
                                      }.bind(this),
                                    ).length > 0 && (
                                      <TextField
                                        id="room_numbers"
                                        value={row.room_numbers}
                                        disabled
                                        emptyValue={'unknown'}
                                        onChange={event => this.handleChange('room_numbers', event.target.value, index, 1)}
                                        select>
                                        <MenuItem value={'unknown'}>
                                          <IntlMessages id="resdetails.NA" />
                                        </MenuItem>
                                        {this.props.auth.authUser.rooms
                                          .filter(
                                            function(itemx) {
                                              return itemx.hotelid == this.state.hotel_id && itemx.rtId == row.room_id;
                                            }.bind(this),
                                          )
                                          .map((t, idx) => (
                                            <MenuItem value={t.ID}>{t.Name}</MenuItem>
                                          ))}
                                      </TextField>
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {getMyDate2(row.checkin, this.props.auth.authUser.language)}
                                    {this.state.readOnly == false && (
                                      <IconButton onClick={e => this.handleClick(e, 'modifyreservation', row)}>
                                        <EditIcon />
                                      </IconButton>
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {getMyDate2(row.checkout, this.props.auth.authUser.language)}
                                    {this.state.readOnly == false && (
                                      <IconButton onClick={e => this.handleClick(e, 'modifyreservation', row)}>
                                        <EditIcon />
                                      </IconButton>
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {row.rooms}
                                    {this.state.readOnly == false && (
                                      <IconButton onClick={e => this.handleClick(e, 'modifyreservation', row)}>
                                        <EditIcon />
                                      </IconButton>
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {row.adults}
                                    {this.state.readOnly == false && (
                                      <IconButton onClick={e => this.handleClick(e, 'modifyreservation', row)}>
                                        <EditIcon />
                                      </IconButton>
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    {row.children}
                                    {this.state.readOnly == false && (
                                      <IconButton onClick={e => this.handleClick(e, 'modifyreservation', row)}>
                                        <EditIcon />
                                      </IconButton>
                                    )}

                                    {row.childAges != '' && (
                                      <>
                                        <br />
                                        {'(' + row.childAges + ')'}
                                      </>
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      id="guestName"
                                      InputProps={{
                                        readOnly: this.state.readOnly,
                                      }}
                                      value={row.rate_id}
                                      onChange={event => this.handleChange('rate_id', event.target.value, index, 1)}
                                      select>
                                      <MenuItem value="0">Standard</MenuItem>
                                      {this.props.auth.authUser.rates
                                        .filter(
                                          function(itemx) {
                                            return itemx.hotel_id == this.state.hotel_id;
                                          }.bind(this),
                                        )
                                        .map((t, idx) => (
                                          <MenuItem value={t.id}>{t.name}</MenuItem>
                                        ))}
                                    </TextField>
                                  </TableCell>
                                  <TableCell>
                                    {row.rate_id != 0 && this.getMealPlan(row.rate_id)}
                                    {row.rate_id == 0 && (
                                      <TextField
                                        id="guestName"
                                        value={row.meal_plan_id}
                                        onChange={event => this.handleChange('meal_plan_id', event.target.value, index, 1)}
                                        InputProps={{
                                          readOnly: this.state.readOnly,
                                        }}
                                        select>
                                        {this.props.auth.authUser.services
                                          .filter(
                                            function(itemx) {
                                              return itemx.hotelid == this.state.hotel_id && itemx.ID > 0;
                                            }.bind(this),
                                          )
                                          .map((t, idx) => (
                                            <MenuItem value={t.ID}>{t.Name}</MenuItem>
                                          ))}
                                      </TextField>
                                    )}
                                  </TableCell>
                                  <TableCell>
                                    <TextField
                                      id="guestName"
                                      value={row.price}
                                      InputProps={{
                                        readOnly: this.state.readOnly,
                                      }}
                                      onChange={event => this.handleChange('price', event.target.value, index, 1)}
                                    />{' '}
                                    {row.currency}
                                    {row.taxes > 0 && (
                                      <>
                                        <br />
                                        (with taxes:{' '}
                                        {myFormatPrice(
                                          parseFloat(row.priceo) + parseFloat(row.taxes),

                                          this.props.auth.authUser.numberMode,
                                        )}
                                        )
                                      </>
                                    )}
                                  </TableCell>
                                </TableRow>
                                <TableRow key={row.id + 'extra'}>
                                  <TableCell colSpan={10}>{row.RoomData != '' && parse(row.RoomData)}</TableCell>
                                </TableRow>
                              </>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <br />
                      {this.state.readOnly == false && (
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.myButton}
                          disabled={false}
                          onClick={e => this.handleClick(e, 'addroom')}>
                          <IntlMessages id="addRoom" />
                        </Button>
                      )}
                    </Box>
                  </>
                )}
                <Box>
                  <TextField
                    label={<IntlMessages id="res.guestComments" />}
                    id="comment"
                    name="comment"
                    margin="normal"
                    rows={6}
                    variant="outlined"
                    fullWidth
                    multiline="true"
                    InputProps={{
                      readOnly: mode == 1 && this.state.readOnly,
                    }}
                    value={this.state.comment}
                    onChange={event => this.handleChange('comment', event.target.value, -1, 0)}
                  />
                </Box>
                {mode == 0 && [20].includes(userRole) && this.state.rows[0] != null && this.state.rows[0].status != 6 && (
                  <Box>
                    <Box display="flex" alignItems="center" className={classes.mainBox}>
                      <Box sx={{ marginLeft: '15px' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.myButton}
                          onClick={e => this.handleClick(e, 'downloadConfirmation2')}>
                          <IntlMessages id="res.downloadConfirmation2" />
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )}
                {mode == 0 && [10, 11, 12, 16].includes(userRole) && (
                  <Box>
                    <Box display="flex" alignItems="center" className={classes.mainBox}>
                      <Box>
                        <IntlMessages id="language" />
                      </Box>
                      <Box sx={{ marginLeft: '15px' }}>
                        <TextField
                          id="priceModel"
                          name="RoomId"
                          select
                          size="small"
                          inputProps={{ min: 0, style: { textAlign: 'center' } }}
                          margin="small"
                          variant="outlined"
                          className={classes.textFieldRoot2}
                          value={this.state.confirmationLanguage}
                          onChange={event => this.handleChange('confirmationLanguage', event.target.value, -1, 0)}>
                          <MenuItem value="en">
                            <IntlMessages id="english" />
                          </MenuItem>
                          <MenuItem value="de">
                            <IntlMessages id="german" />
                          </MenuItem>
                          <MenuItem value="it">
                            <IntlMessages id="italian" />
                          </MenuItem>
                          <MenuItem value="hr">
                            <IntlMessages id="croatian" />
                          </MenuItem>
                          <MenuItem value="sl">
                            <IntlMessages id="slovenian" />
                          </MenuItem>
                          <MenuItem value="al">
                            <IntlMessages id="albanian" />
                          </MenuItem>
                        </TextField>
                      </Box>
                      <Box sx={{ marginLeft: '15px' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.myButton}
                          onClick={e => this.handleClick(e, 'downloadConfirmation')}>
                          {this.state.rows[0] != null && this.state.rows[0].status < 2 && (
                            <IntlMessages id="resdetails.offerPDF" />
                          )}
                          {this.state.rows[0] != null && this.state.rows[0].status == 2 && (
                            <IntlMessages id="res.reservationConfirmation" />
                          )}
                        </Button>
                      </Box>
                      {this.state.rows[0] != null && this.state.rows[0].status != 6 && (
                        <Box sx={{ marginLeft: '15px' }}>
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.myButton}
                            onClick={e => this.handleClick(e, 'downloadConfirmation2')}>
                            <IntlMessages id="res.downloadConfirmation2" />
                          </Button>
                        </Box>
                      )}

                      <Box sx={{ marginLeft: '15px' }}>
                        <TextField
                          label={<IntlMessages id="res.guestEmail" />}
                          id="guestName"
                          value={this.state.guestEmail}
                          fullWidth
                          onChange={event => this.handleChange('guestEmail', event.target.value, -1, 0)}
                        />
                      </Box>
                      <Box sx={{ marginLeft: '15px' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.myButton}
                          onClick={e => this.handleClick(e, 'sendConfirmation')}>
                          <IntlMessages id="res.sendConfirmation" />
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )}
              </TabPanel>

              <TabPanel value={this.state.tabroom} index={1}>
                <Box className={classes.boxTop}>
                  <CmtGridView
                    data={this.state.data2}
                    renderRow={this.renderRow}
                    itemPadding={10}
                    responsive={{
                      xs: 1,
                      sm: 2,
                      md: 2,
                      lg: 2,
                      xl: 3,
                    }}
                    renderRow={(item, index) => (
                      <Box display="flex" alignItems="center" key={index}>
                        {item.icon}
                        <Box>
                          <Box fontSize={12} color="text.secondary">
                            {item.title}
                          </Box>
                          <Box className={classes.columnRoot}>{item.desc}</Box>
                        </Box>
                      </Box>
                    )}
                  />
                </Box>
              </TabPanel>

              <TabPanel value={this.state.tabroom} index={2}>
                {mode == 1 && (
                  <Box>
                    <TableContainer component={Paper} className={classes.root}>
                      <Table className={classes.table} size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <IntlMessages id="res.guestName" />
                            </TableCell>
                            <TableCell width="50" align="center">
                              <IntlMessages id="res.sex" />
                            </TableCell>
                            <TableCell width="150" align="center">
                              <IntlMessages id="res.city" />
                            </TableCell>

                            <TableCell width="150" align="center">
                              <IntlMessages id="res.country" />
                            </TableCell>

                            <TableCell align="right" width="150">
                              <IntlMessages id="res.guestDateOfBirth" />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.rows.map(row => (
                            <TableRow key={row.name}>
                              <TableCell component="th" scope="row">
                                {row.name}
                              </TableCell>
                              <TableCell align="right">{row.sex}</TableCell>
                              <TableCell align="right">{row.city}</TableCell>
                              <TableCell align="right">{row.country}</TableCell>
                              <TableCell align="right">{getMyDate4(row.dateOfBirth, 'hr')}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                )}
              </TabPanel>

              {mode == 0 && (
                <>
                  <TabPanel value={this.state.tabroom} index={1}>
                    <Box className={classes.boxTop}>
                      <Grid container>
                        <Grid item xs={12} sm={6} xl={6}>
                          <Box display="flex" alignItems="center" className={classes.mainBox}>
                            <Box className={classes.mainBox}>
                              <Box fontSize={12} color="text.secondary">
                                <IntlMessages id="viewClient.name" />
                              </Box>
                              <Box className={classes.columnRoot}>
                                <TextField
                                  id="guestName"
                                  value={this.state.guestName}
                                  fullWidth
                                  onChange={event => this.handleChange('guestName', event.target.value, -1, 0)}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} xl={6}>
                          <Box display="flex" alignItems="center">
                            <Box className={classes.mainBox}>
                              <Box fontSize={12} color="text.secondary"></Box>
                              <Box className={classes.columnRoot}></Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} xl={6}>
                          <Box display="flex" alignItems="center" className={classes.mainBox}>
                            <Box className={classes.mainBox}>
                              <Box fontSize={12} color="text.secondary">
                                <IntlMessages id="res.city" />
                              </Box>
                              <Box className={classes.columnRoot}>
                                <TextField
                                  id="guestName"
                                  value={this.state.guestCity}
                                  fullWidth
                                  onChange={event => this.handleChange('guestCity', event.target.value, -1, 0)}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} xl={6}>
                          <Box display="flex" alignItems="center" className={classes.mainBox}>
                            <Box className={classes.mainBox}>
                              <Box fontSize={12} color="text.secondary">
                                <IntlMessages id="viewClient.country" />
                              </Box>
                              <Box className={classes.columnRoot}>
                                <TextField
                                  id="guestName"
                                  value={this.state.guestCountry}
                                  fullWidth
                                  select
                                  onChange={event => this.handleChange('guestCountry', event.target.value, -1, 0)}>
                                  {countriesx.map(item => (
                                    <MenuItem key={item.id} value={item.id}>
                                      {item.value}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} xl={6}>
                          <Box display="flex" alignItems="center" className={classes.mainBox}>
                            <Box className={classes.mainBox}>
                              <Box fontSize={12} color="text.secondary">
                                <IntlMessages id="viewClient.company" />
                              </Box>
                              <Box className={classes.columnRoot}>
                                <TextField
                                  id="guestName"
                                  value={this.state.guestCompany}
                                  fullWidth
                                  onChange={event => this.handleChange('guestCompany', event.target.value, -1, 0)}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} xl={6}>
                          <Box display="flex" alignItems="center" className={classes.mainBox}>
                            <Box className={classes.mainBox}>
                              <Box fontSize={12} color="text.secondary">
                                <IntlMessages id="register.taVAT" />
                              </Box>
                              <Box className={classes.columnRoot}>
                                <TextField
                                  id="guestName"
                                  value={this.state.guestVat}
                                  fullWidth
                                  onChange={event => this.handleChange('guestVat', event.target.value, -1, 0)}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} xl={6}>
                          <Box display="flex" alignItems="center" className={classes.mainBox}>
                            <Box className={classes.mainBox}>
                              <Box fontSize={12} color="text.secondary">
                                <IntlMessages id="viewClient.phone" />
                              </Box>
                              <Box className={classes.columnRoot}>
                                <TextField
                                  id="guestName"
                                  value={this.state.guestPhone}
                                  fullWidth
                                  onChange={event => this.handleChange('guestPhone', event.target.value, -1, 0)}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} xl={6}>
                          <Box display="flex" alignItems="center" className={classes.mainBox}>
                            <Box className={classes.mainBox}>
                              <Box fontSize={12} color="text.secondary">
                                <IntlMessages id="viewClient.birth" />
                              </Box>

                              <Box className={classes.columnRoot}>
                                {this.state.guestBirth != '0000-00-00' && this.state.guestBirth}
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} xl={6}>
                          <Box display="flex" alignItems="center" className={classes.mainBox}>
                            <Box className={classes.mainBox}>
                              <Box fontSize={12} color="text.secondary">
                                <IntlMessages id="viewClient.email" />
                              </Box>
                              <Box className={classes.columnRoot}>
                                <TextField
                                  id="guestName"
                                  value={this.state.guestEmail}
                                  fullWidth
                                  onChange={event => this.handleChange('guestEmail', event.target.value, -1, 0)}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} xl={6}>
                          <Box display="flex" alignItems="center" className={classes.mainBox}>
                            <Box className={classes.mainBox}>
                              <Box fontSize={12} color="text.secondary">
                                <IntlMessages id="viewClient.email2" />
                              </Box>
                              <Box className={classes.columnRoot}>
                                <TextField
                                  id="addEmail"
                                  value={this.state.addEmail}
                                  fullWidth
                                  onChange={event => this.handleChange('addEmail', event.target.value, -1, 0)}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                    {this.state.changed && (
                      <Box className={classes.boxClass}>
                        <Button
                          variant="contained"
                          color="secondary"
                          className={classes.myButton}
                          onClick={e => this.runAction(e, 'cancel')}
                          startIcon={<Cancel />}>
                          <IntlMessages id="cockpit.cancel" />
                        </Button>
                        <Button
                          variant="contained"
                          color="secondary"
                          className={classes.myButton}
                          onClick={e => this.runAction(e, 'save')}
                          startIcon={<CloudDone />}>
                          <IntlMessages id="cockpit.save" />
                        </Button>
                      </Box>
                    )}
                  </TabPanel>
                  <TabPanel value={this.state.tabroom} index={2}>
                    {mode == 0 && (
                      <Box>
                        {this.state.res != null && this.state.res.data.Data[0].Welcomesent != null && (
                          <Box mb={2}>
                            <CheckCircleIcon /> <IntlMessages id="status.sentOn" />
                            {': '}
                            {getMyDate3(this.state.res.data.Data[0].Welcomesent, this.props.auth.authUser.language)}
                          </Box>
                        )}
                        {this.state.res != null &&
                          this.state.res.data.Data[0].Welcomesent == null &&
                          this.state.guestEmail != '' && (
                            <>
                              <TextField
                                id="priceModel"
                                name="RoomId"
                                select
                                size="small"
                                inputProps={{ min: 0, style: { textAlign: 'center' } }}
                                margin="small"
                                variant="outlined"
                                className={classes.textFieldRoot2}
                                value={this.state.confirmationLanguage}
                                onChange={event => this.handleChange('confirmationLanguage', event.target.value, -1, 0)}>
                                <MenuItem value="en">
                                  <IntlMessages id="english" />
                                </MenuItem>
                                <MenuItem value="de">
                                  <IntlMessages id="german" />
                                </MenuItem>
                                <MenuItem value="it">
                                  <IntlMessages id="italian" />
                                </MenuItem>
                                <MenuItem value="hr">
                                  <IntlMessages id="croatian" />
                                </MenuItem>
                                <MenuItem value="sl">
                                  <IntlMessages id="slovenian" />
                                </MenuItem>
                              </TextField>
                              <Button
                                onClick={() => this.handleAction('sendinvitation', 0)}
                                variant="contained"
                                color="primary">
                                <IntlMessages id="pages.selfCheckInEmail" />
                              </Button>
                            </>
                          )}

                        {
                          <Box mb={2}>
                            <Typography component="div" variant="h4" className={classes.titleRoot}>
                              <IntlMessages id="res.persons" /> {this.state.guestInfo.length}
                            </Typography>
                            <Button onClick={() => this.handleAction('addnew', 0)} variant="contained" color="primary">
                              <IntlMessages id="selfcheckin.addNew" />
                            </Button>
                          </Box>
                        }
                        {this.state.guestInfo.map((item, index) => (
                          <Box mb={2}>
                            <Box className={classes.boxClass2}>
                              <Typography className={classes.titleRoot2} noWrap display="inline">
                                #{index + 1}
                              </Typography>
                              <br />
                              {item.fromDate != '' && item.fromDate != '0000-00-00' && (
                                <>
                                  Stay: {item.fromDate}
                                  {' - '}
                                  {item.toDate}
                                </>
                              )}
                              <br />
                              {item.confirmationId != '' && <>Confirmation ID: {item.confirmationId}</>}
                              {item.shared == 1 && (
                                <Chip
                                  size="small"
                                  label="Share"
                                  style={{
                                    color: '#ffffff',
                                    fontWeight: 'bold',
                                    borderRadius: 2,
                                    backgroundColor: '#034880',
                                  }}
                                />
                              )}{' '}
                              {item.sent == 1 && (
                                <Chip
                                  size="small"
                                  label={<IntlMessages id="PMS" />}
                                  style={{
                                    color: '#ffffff',
                                    fontWeight: 'bold',
                                    borderRadius: 2,
                                    backgroundColor: '#034880',
                                  }}
                                />
                              )}
                              {this.state.rows.length > 1 && (
                                <TextField
                                  id="priceModel"
                                  name="RoomId"
                                  select
                                  size="small"
                                  inputProps={{ min: 0, style: { textAlign: 'center' } }}
                                  margin="small"
                                  variant="outlined"
                                  className={classes.textFieldRoot2}
                                  value={item.RoomId}
                                  onChange={event => this.handleChange2('RoomId', event.target.value, index, -1, 1)}>
                                  {this.state.rows.map((idx2, idx) => (
                                    <MenuItem value={idx + 1}>
                                      <IntlMessages id="room" /> {idx + 1}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              )}
                              <IconButton aria-label="delete" onClick={() => this.handleAction('delete', index)}>
                                <DeleteIcon />
                              </IconButton>
                              <Button
                                onClick={e => this.handleClick(e, 'getGuest', index)}
                                variant="contained"
                                color="primary">
                                <IntlMessages id="findClient" />
                              </Button>
                            </Box>
                            <GridContainer spacing={2}>
                              <Grid item xs={12} sm={2} xl={2}>
                                <TextField
                                  label=<IntlMessages id="selfcheckin.firstName" />
                                  fullWidth
                                  value={item.FirstName}
                                  margin="normal"
                                  variant="standard"
                                  defaultValue=""
                                  onChange={event => this.handleChange2('FirstName', event.target.value, index, -1, 1)}
                                  className={classes.textFieldRoot}
                                />
                              </Grid>
                              <Grid item xs={12} sm={2} xl={2}>
                                <TextField
                                  label=<IntlMessages id="selfcheckin.lastName" />
                                  fullWidth
                                  value={item.LastName}
                                  margin="normal"
                                  variant="standard"
                                  defaultValue=""
                                  onChange={event => this.handleChange2('LastName', event.target.value, index, -1, 1)}
                                  className={classes.textFieldRoot}
                                />
                              </Grid>
                              <Grid item xs={12} sm={2} xl={2}>
                                <TextField
                                  label=<IntlMessages id="selfcheckin.sex" />
                                  id="priceModel"
                                  name="sex"
                                  select
                                  margin="normal"
                                  fullWidth
                                  className={classes.textFieldRoot}
                                  value={item.Sex}
                                  onChange={event => this.handleChange2('Sex', event.target.value, index, -1, 1)}>
                                  {guestEngine == 0 && (
                                    <MenuItem value="0">
                                      <IntlMessages id="selfcheckin.male" />
                                    </MenuItem>
                                  )}
                                  {guestEngine == 0 && (
                                    <MenuItem value="1">
                                      <IntlMessages id="selfcheckin.female" />{' '}
                                    </MenuItem>
                                  )}
                                  {guestEngine == 1 && (
                                    <MenuItem value="1">
                                      <IntlMessages id="selfcheckin.male" />
                                    </MenuItem>
                                  )}
                                  {guestEngine == 1 && (
                                    <MenuItem value="2">
                                      <IntlMessages id="selfcheckin.female" />{' '}
                                    </MenuItem>
                                  )}
                                  {guestEngine == 1 && (
                                    <MenuItem value="3">
                                      <IntlMessages id="selfcheckin.otherSex" />{' '}
                                    </MenuItem>
                                  )}
                                </TextField>
                              </Grid>
                              <Grid item xs={12} sm={2} xl={2}>
                                <KeyboardDatePicker
                                  variant="inline"
                                  format="DD/MM/yyyy"
                                  margin="normal"
                                  id="date2"
                                  name="BirthDate"
                                  label=<IntlMessages id="selfcheckin.birthDate" />
                                  fullWidth
                                  renderInput={params => <TextField {...params} />}
                                  value={item.BirthDate}
                                  autoOk="true"
                                  onChange={date => this.handleChange2('BirthDate', getMyDate(date), index, -1, 1)}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={2} xl={2}>
                                <TextField
                                  label=<IntlMessages id="selfcheckin.birthCountry" />
                                  fullWidth
                                  value={item.BirthCountry}
                                  margin="normal"
                                  variant="standard"
                                  defaultValue=""
                                  select
                                  onChange={event => this.handleChange2('BirthCountry', event.target.value, index)}
                                  className={classes.textFieldRoot}>
                                  {countries.map(t => (
                                    <MenuItem value={t.code}>{t.name}</MenuItem>
                                  ))}
                                </TextField>
                              </Grid>
                              {guestEngine == 1 && (
                                <Grid item xs={12} sm={2} xl={2}>
                                  <TextField
                                    label=<IntlMessages id="selfcheckin.birthCity" />
                                    fullWidth
                                    value={item.BirthCity}
                                    margin="normal"
                                    variant="standard"
                                    defaultValue=""
                                    onChange={event => this.handleChange2('BirthCity', event.target.value, index)}
                                    className={classes.textFieldRoot}
                                  />
                                </Grid>
                              )}

                              <Grid item xs={12} sm={2} xl={2}>
                                <TextField
                                  label=<IntlMessages id="selfcheckin.document" />
                                  id="priceModel"
                                  name="idType"
                                  select
                                  fullWidth
                                  margin="normal"
                                  className={classes.textFieldRoot}
                                  value={item.idType}
                                  onChange={event => this.handleChange2('idType', event.target.value, index)}>
                                  {this.props.auth.authUser.hotels.find(({ id }) => id === this.state.hotel_id).EV == 1 &&
                                    this.props.auth.authUser.EVData.filter(({ vrsta, engine }) => {
                                      return vrsta == 2 && engine == guestEngine;
                                    }).map(item => <MenuItem value={item.sifra}>{item.naziv}</MenuItem>)}
                                  {this.props.auth.authUser.hotels.find(({ id }) => id === this.state.hotel_id).EV == 0 &&
                                    documents.map(item => <MenuItem value={item.id}>{item.name}</MenuItem>)}
                                </TextField>
                              </Grid>
                              <Grid item xs={12} sm={2} xl={2}>
                                <TextField
                                  label=<IntlMessages id="selfcheckin.idNumber" />
                                  fullWidth
                                  value={item.idNumber}
                                  margin="normal"
                                  variant="standard"
                                  defaultValue=""
                                  onChange={event => this.handleChange2('idNumber', event.target.value, index)}
                                  className={classes.textFieldRoot}
                                />
                              </Grid>
                              {guestEngine == 0 && (
                                <Grid item xs={12} sm={2} xl={2}>
                                  <TextField
                                    label=<IntlMessages id="selfcheckin.city" />
                                    fullWidth
                                    value={item.City}
                                    margin="normal"
                                    variant="standard"
                                    defaultValue=""
                                    onChange={event => this.handleChange2('City', event.target.value, index)}
                                    className={classes.textFieldRoot}
                                  />
                                </Grid>
                              )}
                              {guestEngine == 0 && (
                                <Grid item xs={12} sm={2} xl={2}>
                                  <TextField
                                    label=<IntlMessages id="selfcheckin.country" />
                                    fullWidth
                                    value={item.Country}
                                    margin="normal"
                                    variant="standard"
                                    defaultValue=""
                                    select
                                    onChange={event => this.handleChange2('Country', event.target.value, index)}
                                    className={classes.textFieldRoot}>
                                    {countries.map(t => (
                                      <MenuItem value={t.code}>{t.name}</MenuItem>
                                    ))}
                                  </TextField>
                                </Grid>
                              )}
                              <Grid item xs={12} sm={2} xl={2}>
                                <TextField
                                  label=<IntlMessages id="selfcheckin.citizenship" />
                                  fullWidth
                                  value={item.Citizenship}
                                  margin="normal"
                                  variant="standard"
                                  defaultValue=""
                                  select
                                  onChange={event => this.handleChange2('Citizenship', event.target.value, index)}
                                  className={classes.textFieldRoot}>
                                  {countries.map(t => (
                                    <MenuItem value={t.code}>{t.name}</MenuItem>
                                  ))}
                                </TextField>
                              </Grid>
                              {guestEngine == 0 && (
                                <Grid item xs={12} sm={2} xl={2}>
                                  {this.props.auth.authUser.hotels.find(({ id }) => id === this.state.hotel_id).EV == 1 && (
                                    <TextField
                                      label=<IntlMessages id="selfcheckin.taxType" />
                                      id="priceModel"
                                      name="idType"
                                      select
                                      fullWidth
                                      margin="normal"
                                      className={classes.textFieldRoot}
                                      value={item.guestTax}
                                      onChange={event => this.handleChange2('guestTax', event.target.value, index)}>
                                      {this.props.auth.authUser.hotels.find(({ id }) => id === this.state.hotel_id).EV ==
                                        1 &&
                                        this.props.auth.authUser.EVData.filter(({ vrsta }) => {
                                          return vrsta == 1;
                                        }).map(item => <MenuItem value={item.sifra}>{item.naziv}</MenuItem>)}
                                    </TextField>
                                  )}
                                </Grid>
                              )}
                            </GridContainer>
                          </Box>
                        ))}
                        <GridContainer spacing={2}>
                          <Grid item xs={12} sm={4} xl={4}>
                            <Button
                              onClick={() => this.handleAction('checkIn2')}
                              variant="contained"
                              color="primary"
                              fullwWidth>
                              <IntlMessages id="guests.saveGuests" />
                            </Button>
                          </Grid>
                          <Grid item xs={12} sm={4} xl={4}>
                            <Button
                              onClick={() => this.handleAction('checkIn')}
                              variant="contained"
                              color="secondary"
                              fullWidth>
                              <IntlMessages id="doCheckIn" />
                            </Button>
                          </Grid>
                        </GridContainer>
                        {this.state.res != null && (
                          <>
                            <Typography variant="h1" className={classes.title}>
                              Self check in link
                            </Typography>
                            <Grid container>
                              <Grid xs={12} sm={10} xl={10} item>
                                <TextField
                                  id="outlined-read-only-input"
                                  label="English"
                                  defaultValue={this.state.sci['en']}
                                  fullWidth
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={2} xl={2}>
                                <Button
                                  onClick={() => this.handleAction('openCheckIn', 'en')}
                                  variant="contained"
                                  color="primary"
                                  fullWidth>
                                  Open
                                </Button>
                              </Grid>
                              <Grid xs={12} sm={10} xl={10} item>
                                <TextField
                                  id="outlined-read-only-input"
                                  label="Croatian/Hrvatski"
                                  defaultValue={this.state.sci['hr']}
                                  fullWidth
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={12} sm={2} xl={2}>
                                <Button
                                  onClick={() => this.handleAction('openCheckIn', 'hr')}
                                  variant="contained"
                                  color="primary"
                                  fullWidth>
                                  Open
                                </Button>
                              </Grid>
                            </Grid>
                          </>
                        )}
                      </Box>
                    )}
                    {mode == 1 && (
                      <Box>
                        <TableContainer component={Paper} className={classes.root}>
                          <Table className={classes.table} size="small" aria-label="a dense table">
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  <IntlMessages id="res.guestName" />
                                </TableCell>
                                <TableCell width="50" align="center">
                                  <IntlMessages id="res.sex" />
                                </TableCell>
                                <TableCell width="150" align="center">
                                  <IntlMessages id="res.city" />
                                </TableCell>

                                <TableCell width="150" align="center">
                                  <IntlMessages id="res.country" />
                                </TableCell>

                                <TableCell align="right" width="150">
                                  <IntlMessages id="res.guestDateOfBirth" />
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.state.rows.map(row => (
                                <TableRow key={row.name}>
                                  <TableCell component="th" scope="row">
                                    {row.name}
                                  </TableCell>
                                  <TableCell align="right">{row.sex}</TableCell>
                                  <TableCell align="right">{row.city}</TableCell>
                                  <TableCell align="right">{row.country}</TableCell>
                                  <TableCell align="right">{getMyDate4(row.dateOfBirth, 'hr')}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    )}
                  </TabPanel>
                  <TabPanel value={this.state.tabroom} index={3}>
                    <Box>
                      <TableContainer component={Paper} className={classes.root}>
                        <Table className={classes.table} size="small" aria-label="a dense table">
                          <TableHead>
                            <TableRow>
                              <TableCell>
                                <IntlMessages id="extras.serviceName" />
                              </TableCell>
                              <TableCell width="200" align="center">
                                <IntlMessages id="extras.serviceType" />
                              </TableCell>
                              <TableCell width="150" align="center">
                                <IntlMessages id="extras.quantity" />
                              </TableCell>
                              <TableCell width="350" align="center">
                                <IntlMessages id="extras.price" />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.extras.map(row => (
                              <TableRow key={row.id}>
                                <TableCell component="th" scope="row">
                                  <IconButton onClick={() => this.handleClick(row.id, 'deleteEItem')}>
                                    <DeleteIcon />
                                  </IconButton>
                                  {row.name}
                                </TableCell>
                                <TableCell align="right">{this.getExtraType(row.type)}</TableCell>
                                <TableCell align="right">
                                  {row.quantity}
                                  {this.state.readOnly == false && 1 == 0 && (
                                    <IconButton onClick={e => this.handleClick(e, 'modifiyequantity', row)}>
                                      <EditIcon />
                                    </IconButton>
                                  )}
                                </TableCell>
                                <TableCell align="right">
                                  {myFormatPrice(row.price, this.props.auth.authUser.numberMode) + ' ' + row.currency}
                                  {row.discount > 0 && (
                                    <>
                                      {' -'}
                                      {row.discount}
                                      {'%'}
                                    </>
                                  )}
                                  {this.props.auth.authUser.role != 20 && (
                                    <IconButton
                                      aria-label="close"
                                      className={classes.closeButton}
                                      onClick={() => this.handleClick(row.id, 'modifyEDiscont')}>
                                      <Loyalty />
                                    </IconButton>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))}
                            <TableRow key={-1}>
                              <TableCell component="th" scope="row">
                                <TextField
                                  label={<IntlMessages id="res.service" />}
                                  id="service_id"
                                  name="service_id"
                                  select
                                  margin="normal"
                                  className={classes.currency}
                                  fullWidth
                                  value={this.state.newEService_id}
                                  onChange={event => this.handleChange('newEService_id', event.target.value, -1, 0)}>
                                  {this.props.auth.authUser.services
                                    .filter(
                                      function(itemx) {
                                        return (
                                          itemx.hotelid == this.state.hotel_id &&
                                          itemx.ID < -1 &&
                                          itemx.customCurrency == usedCurrency
                                        );
                                      }.bind(this),
                                    )
                                    .map((t, idx) => (
                                      <MenuItem value={t.ID}>{t.Name}</MenuItem>
                                    ))}
                                </TextField>
                                <br />
                                <Button
                                  color="primary"
                                  varriant="contained"
                                  onClick={() => this.handleClick(-1, 'addEItem')}
                                  startIcon={<AddIcon />}></Button>
                              </TableCell>
                              <TableCell align="right"></TableCell>
                              <TableCell align="right">
                                <TextField
                                  onChange={event => this.handleChange('newEQuantity', event.target.value, -1, 0)}
                                  fullWidth
                                  value={this.state.newEQuantity}
                                />
                              </TableCell>
                              <TableCell align="right"></TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </TabPanel>
                  <TabPanel value={this.state.tabroom} index={4}>
                    <Invoice
                      mode="create"
                      resId={this.state.invoiceId}
                      resTitle={this.state.selInvoiceTitle}
                      bookingId={this.state.resId}
                      open={this.state.tabroom == 4}
                      prepayment={0}
                      doRefresh={this.refresh}
                      status={this.state.setStatus}
                      hotelId={this.state.hotel_id}
                      viewMode={1}
                      setState={p => {
                        this.setState(p);
                      }}
                    />
                  </TabPanel>
                  <TabPanel value={this.state.tabroom} index={5}>
                    <CmtCardContent>
                      <GridContainer>
                        <Grid xs={12}>
                          <TableContainer component={Paper} className={classes.root}>
                            <Table className={classes.table} size="small" aria-label="a dense table">
                              <TableHead>
                                <TableRow>
                                  <TableCell>
                                    <IntlMessages id="invoice.createdDate" />
                                  </TableCell>
                                  <TableCell width="50" align="center">
                                    <IntlMessages id="invoice.type" />
                                  </TableCell>
                                  <TableCell width="150" align="center">
                                    <IntlMessages id="invoice.label" />
                                  </TableCell>

                                  <TableCell width="150" align="center">
                                    <IntlMessages id="invoice.total" />
                                  </TableCell>
                                  <TableCell width="150" align="center">
                                    <IntlMessages id="invoice.action" />
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.invoices.length == 0 && (
                                  <TableRow>
                                    <TableCell colspan="5">
                                      <IntlMessages id="bookings.paymentStatus1" />
                                    </TableCell>
                                  </TableRow>
                                )}
                                {this.state.invoices.map(row => (
                                  <TableRow key={row.id}>
                                    <TableCell component="th" scope="row">
                                      {getMyDate3(row.datetime2, this.props.auth.authUser.language)}
                                    </TableCell>
                                    <TableCell align="right">
                                      {row.prepayment == 0 ? (
                                        <IntlMessages id="invoice.type0" />
                                      ) : (
                                        <IntlMessages id="invoice.type1" />
                                      )}
                                    </TableCell>
                                    <TableCell align="right">{row.label}</TableCell>
                                    <TableCell align="right">
                                      {myFormatPrice(parseFloat(row.total), this.props.auth.authUser.numberMode) +
                                        ' ' +
                                        row.currency}
                                    </TableCell>
                                    <TableCell align="right">
                                      {[10, 12, 16].includes(userRole) &&
                                        row.prepayment == 1 &&
                                        row.cancel_id == null &&
                                        row.total > 0 && (
                                          <Button
                                            onClick={e => this.handleClick(e, 'refundShow', row)}
                                            variant="contained"
                                            color="primary"
                                            size="small">
                                            <IntlMessages id="invoice.refund" />
                                          </Button>
                                        )}
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        onClick={e =>
                                          this.setState({ invoiceMode: 'view', viewInvoiceVisible: true, invoiceId: row.id })
                                        }>
                                        <IntlMessages id="invoice.view" />
                                      </Button>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                        {this.state.rows[0] != null && this.state.rows[0].status == 2 && [10, 12, 16].includes(userRole) && (
                          <Grid xs={12}>
                            <Button
                              variant="contained"
                              color="primary"
                              className={classes.myButton}
                              onClick={e => this.handleClick(e, 'createInvoice2')}>
                              <IntlMessages id="bookings.addPrepayment" />
                            </Button>
                          </Grid>
                        )}
                        {[10, 12, 16].includes(userRole) && this.state.rows[0] != null && this.state.rows[0].status != 6 && (
                          <>
                            <Grid xs={12} xl={3} sm={3} container alignItems="center" alignContent="center">
                              <TextField
                                label={<IntlMessages id="res.paymentinfo" />}
                                id="paymentId"
                                name="paymentId"
                                select
                                margin="normal"
                                fullWidth
                                className={classes.currency}
                                value={this.state.paymentId}
                                onChange={event => this.handleChange('paymentId', event.target.value, -1, 0)}>
                                {this.props.auth.authUser.payments
                                  .filter(
                                    function(itemx) {
                                      return itemx.hotel_id == this.state.hotel_id;
                                    }.bind(this),
                                  )
                                  .map((t, idx) => (
                                    <MenuItem value={t.id}>{t.name}</MenuItem>
                                  ))}
                              </TextField>
                            </Grid>
                            <Grid xs={12} sm={3} xl={3}>
                              <TextField
                                label={<IntlMessages id="res.customPrepayment" />}
                                id="discount"
                                name="discount"
                                select
                                margin="normal"
                                fullWidth
                                className={classes.formControl}
                                value={this.state.customPrepaymentMode}
                                onChange={event => this.handleChange('customPrepaymentMode', event.target.value, -1, 0)}>
                                <MenuItem value="-1">
                                  <IntlMessages id="res.customPrepayment4" />
                                </MenuItem>
                                <MenuItem value="0">
                                  <IntlMessages id="res.customPrepayment" />
                                </MenuItem>
                                <MenuItem value="1">
                                  <IntlMessages id="res.customPrepayment3" />
                                </MenuItem>
                              </TextField>
                            </Grid>
                            <Grid xs={12} sm={2} xl={2}>
                              {this.state.customPrepaymentMode == 1 && (
                                <>
                                  <TextField
                                    id="guestPhone"
                                    name="guestPhone"
                                    margin="normal"
                                    label={<IntlMessages id="res.customPrepayment" />}
                                    value={this.state.customPrepayment2}
                                    className={classes.formControl}
                                    defaultValue=""
                                    fullWidth
                                    select
                                    onChange={event => this.handleChange('customPrepayment2', event.target.value, -1, 0)}>
                                    <MenuItem value="15">15%</MenuItem>
                                    <MenuItem value="20">20%</MenuItem>
                                    <MenuItem value="25">25%</MenuItem>
                                    <MenuItem value="30">30%</MenuItem>
                                    <MenuItem value="33">33%</MenuItem>
                                    <MenuItem value="35">35%</MenuItem>
                                    <MenuItem value="40">40%</MenuItem>
                                    <MenuItem value="45">45%</MenuItem>
                                    <MenuItem value="50">50%</MenuItem>
                                    <MenuItem value="60">60%</MenuItem>
                                    <MenuItem value="66">66%</MenuItem>
                                    <MenuItem value="70">70%</MenuItem>
                                    <MenuItem value="80">80%</MenuItem>
                                    <MenuItem value="90">90%</MenuItem>
                                    <MenuItem value="100">100%</MenuItem>
                                  </TextField>
                                </>
                              )}

                              {this.state.customPrepaymentMode == 0 && (
                                <>
                                  <TextField
                                    id="guestPhone"
                                    name="guestPhone"
                                    fullWidth
                                    margin="normal"
                                    label={<IntlMessages id="paymentAmount" />}
                                    defaultValue=""
                                    value={this.state.customPrepayment}
                                    onChange={event => this.handleChange('customPrepayment', event.target.value, -1, 0)}
                                  />
                                </>
                              )}
                            </Grid>
                            <Grid xs={12} sm={4} xl={4} container alignItems="flex-end" alignContent="flex-end">
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.myButton}
                                onClick={e => this.handleClick(e, 'savePaymentInfo')}>
                                <IntlMessages id="bookings.savePayment" />
                              </Button>
                            </Grid>
                          </>
                        )}
                        {}
                        {[10, 12, 16].includes(userRole) &&
                          this.state.rows[0] != null &&
                          (this.state.rows[0].status == 2 || this.state.rows[0].status == 1) && (
                            <>
                              <Grid xs={12} xl={3} sm={3} container alignItems="center" alignContent="center">
                                <TextField
                                  onChange={event => this.handleChange('paymentAmount', event.target.value, -1, 0)}
                                  value={this.state.paymentAmount}
                                />
                                {this.state.res.data.Data[0].currency}
                              </Grid>
                              <Grid xs={12} xl={3} sm={3} container alignItems="center" alignContent="center">
                                <FormControlLabel
                                  value="bottom"
                                  control={
                                    <Checkbox
                                      color="primary"
                                      checked={this.state.sendEmailPayment}
                                      onChange={event => this.handleChange('sendEmailPayment', event.target.checked, -1, 0)}
                                    />
                                  }
                                  label=<IntlMessages id="res.guestEmail2" />
                                  labelPlacement="right"
                                />
                              </Grid>
                              <Grid xs={12} xl={3} sm={3} container alignItems="center" alignContent="center">
                                <TextField
                                  label={<IntlMessages id="res.paymentinfo" />}
                                  id="paymentId"
                                  name="paymentId"
                                  select
                                  margin="normal"
                                  fullWidth
                                  className={classes.currency}
                                  value={this.state.paymentId}
                                  onChange={event => this.handleChange('paymentId', event.target.value, -1, 0)}>
                                  {this.props.auth.authUser.payments
                                    .filter(
                                      function(itemx) {
                                        return itemx.hotel_id == this.state.hotel_id;
                                      }.bind(this),
                                    )
                                    .map((t, idx) => (
                                      <MenuItem value={t.id}>{t.name}</MenuItem>
                                    ))}
                                </TextField>
                              </Grid>
                              <Grid xs={12} xl={3} sm={3} container alignItems="center" alignContent="center">
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className={classes.myButton}
                                  onClick={e => this.handleClick(e, 'requestPayment')}>
                                  <IntlMessages id="bookings.requestPayment" />
                                </Button>
                              </Grid>
                              <Grid xs={12} xl={12} sm={12} container>
                                {this.state.paymentLink}
                              </Grid>
                            </>
                          )}
                        {[20].includes(userRole) &&
                          this.state.rows[0] != null &&
                          (this.state.rows[0].status == 2 || this.state.rows[0].status == 1) && (
                            <>
                              <Grid xs={12} xl={3} sm={3} container alignItems="center" alignContent="center">
                                <TextField
                                  id="guestPhone"
                                  name="guestPhone"
                                  margin="normal"
                                  label={<IntlMessages id="res.customPrepayment" />}
                                  value={this.state.customPrepayment2}
                                  className={classes.formControl}
                                  defaultValue=""
                                  fullWidth
                                  select
                                  onChange={event => this.handleChange('customPrepayment2', event.target.value, -1, 0)}>
                                  <MenuItem value="15">15%</MenuItem>
                                  <MenuItem value="20">20%</MenuItem>
                                  <MenuItem value="25">25%</MenuItem>
                                  <MenuItem value="30">30%</MenuItem>
                                  <MenuItem value="33">33%</MenuItem>
                                  <MenuItem value="35">35%</MenuItem>
                                  <MenuItem value="40">40%</MenuItem>
                                  <MenuItem value="45">45%</MenuItem>
                                  <MenuItem value="50">50%</MenuItem>
                                  <MenuItem value="60">60%</MenuItem>
                                  <MenuItem value="66">66%</MenuItem>
                                  <MenuItem value="70">70%</MenuItem>
                                  <MenuItem value="80">80%</MenuItem>
                                  <MenuItem value="90">90%</MenuItem>
                                  <MenuItem value="100">100%</MenuItem>
                                </TextField>
                              </Grid>
                              <Grid xs={12} xl={3} sm={3} container alignItems="center" alignContent="center">
                                <TextField
                                  label={<IntlMessages id="res.paymentinfo" />}
                                  id="paymentId"
                                  name="paymentId"
                                  select
                                  margin="normal"
                                  fullWidth
                                  className={classes.currency}
                                  value={this.state.paymentId}
                                  onChange={event => this.handleChange('paymentId', event.target.value, -1, 0)}>
                                  {this.props.auth.authUser.payments
                                    .filter(
                                      function(itemx) {
                                        var show = itemx.hotel_id == this.state.hotel_id;
                                        if (this.state.res.data.Data[0].currency != 'KES' && itemx.id == 'mpesa')
                                          show = false;

                                        return show;
                                      }.bind(this),
                                    )
                                    .map((t, idx) => (
                                      <MenuItem value={t.id}>{t.name}</MenuItem>
                                    ))}
                                  <MenuItem value="requestlink">Credit Card Payment - Request Payment Link</MenuItem>
                                </TextField>
                              </Grid>
                              <Grid xs={12} xl={3} sm={3} container alignItems="center" alignContent="center">
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className={classes.myButton}
                                  onClick={e => this.handleClick(e, 'doPayment')}>
                                  <IntlMessages id="bookings.doPayment" />
                                </Button>
                              </Grid>
                              <Grid xs={12} xl={12} sm={12} container>
                                {this.state.paymentLink}
                              </Grid>
                            </>
                          )}
                      </GridContainer>
                    </CmtCardContent>
                  </TabPanel>

                  <TabPanel value={this.state.tabroom} index={7}>
                    <Box>
                      <TableContainer component={Paper} className={classes.root}>
                        <Table className={classes.table} size="small" aria-label="a dense table">
                          <TableHead>
                            <TableRow>
                              <TableCell width="200">
                                <IntlMessages id="bookings.dateModified" />
                              </TableCell>
                              <TableCell align="left">
                                <IntlMessages id="resdetail.action" />
                              </TableCell>
                              <TableCell width="150" align="right"></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.activities.map(row => (
                              <TableRow key={row.id}>
                                <TableCell component="th" scope="row">
                                  {getMyDate3(row.datetime2, this.props.auth.authUser.language)}
                                </TableCell>
                                <TableCell align="left">{row.action}</TableCell>
                                <TableCell align="right">{row.userId}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </TabPanel>
                  <TabPanel value={this.state.tabroom} index={6}>
                    <Messages bookingId={this.state.resId} mode="view" />
                  </TabPanel>
                  <TabPanel value={this.state.tabroom} index={8}>
                    <Box>
                      <TableContainer component={Paper} className={classes.root}>
                        <Table className={classes.table} size="small" aria-label="a dense table">
                          <TableHead>
                            <TableRow>
                              <TableCell width="100">
                                <IntlMessages id="bookings.id" />
                              </TableCell>
                              <TableCell align="left">
                                <IntlMessages id="bookings.property" />
                              </TableCell>
                              <TableCell width="150" align="right">
                                <IntlMessages id="resdetail.action" />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.rows[0] != null &&
                              this.state.rows[0].linkedReservations != null &&
                              this.state.rows[0].linkedReservations.map(row => (
                                <TableRow key={row.id}>
                                  <TableCell component="th" scope="row">
                                    {row.booking_number}
                                  </TableCell>
                                  <TableCell align="left">
                                    {this.props.auth.authUser.hotels.filter(({ id }) => id == row.hotelId)[0].name}
                                  </TableCell>
                                  <TableCell align="right">
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      size="small"
                                      onClick={e =>
                                        this.setState({ hotelId: row.hotelId, resId: row.id }, () => {
                                          this.refresh();
                                        })
                                      }>
                                      <IntlMessages id="invoice.view" />
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </TabPanel>
                </>
              )}
            </>
          )}
        </Dialog>
        <ViewCC
          resId={this.state.selReservationId}
          open={this.state.viewCCVisible}
          anchorEl={this.state.myanchorEl}
          setState={p => {
            this.setState(p);
          }}
        />
        <AddCC
          resId={this.state.selReservationId}
          open={this.state.viewAddCCVisible}
          anchorEl={this.state.myanchorEl}
          doRefresh={p => {
            this.refresh();
          }}
          setState={p => {
            this.setState(p);
          }}
        />
        <ViewClient
          resId={this.state.selReservationId}
          selGuestIndex={this.state.selGuestIndex}
          open={this.state.viewClientVisible}
          anchorEl={this.state.myanchorEl}
          doRefresh={p => {
            this.refresh();
          }}
          setState={p => {
            this.setState(p);
          }}
        />
        <Snackbar open={this.state.showSuccess} autoHideDuration={500} onClose={this.handleClose2}>
          <Alert severity="success">
            <IntlMessages id="message.success" />
          </Alert>
        </Snackbar>
        <Snackbar open={this.state.showFail} autoHideDuration={500} onClose={this.handleClose2}>
          <Alert severity="error">
            <IntlMessages id="message.fail" />
          </Alert>
        </Snackbar>
        <Dialog open={this.state.addVoucherVisible} onClose={() => this.setState({ addVoucherVisible: false })}>
          <DialogTitle>Add Voucher</DialogTitle>
          <DialogContent>
            <form>
              <TextField
                type="file"
                variant="outlined"
                onChange={event => this.handleChange('file', event.target.files[0])}
                fullWidth
              />
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ addVoucherVisible: false })}>Cancel</Button>
            <Button onClick={e => this.handleClick(e, 'addVoucher')}>Upload</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.addPaymentProof} onClose={() => this.setState({ addPaymentProof: false })}>
          <DialogTitle>Add Payment Proof</DialogTitle>
          <DialogContent>
            <form>
              <TextField
                type="file"
                variant="outlined"
                onChange={event => this.handleChange('file', event.target.files[0])}
                fullWidth
              />
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ addPaymentProof: false })}>Cancel</Button>
            <Button onClick={e => this.handleClick(e, 'addPaymentProof')}>Upload</Button>
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.addVoucherVisible2} onClose={() => this.setState({ addVoucherVisible2: false })}>
          <DialogTitle>Modify Voucher Number</DialogTitle>
          <DialogContent>
            <form>
              <TextField
                variant="outlined"
                value={this.state.voucherNumber}
                onChange={event => this.handleChange('voucherNumber', event.target.value)}
                fullWidth
              />
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ addVoucherVisible2: false })}>Cancel</Button>
            <Button onClick={e => this.handleClick(e, 'addVoucher2')}>Update</Button>
          </DialogActions>
        </Dialog>
        <Dialog
          maxWidth="xl"
          sx={{
            '& .MuiDialog-container': {
              '& .MuiPaper-root': {
                width: '100%',
                maxWidth: '500px', // Set your width here
              },
            },
          }}
          open={this.state.extrasDiscountVisible}
          onClose={() => this.setState({ extrasDiscountVisible: false })}>
          <DialogTitle>Extra Service Discount</DialogTitle>
          <DialogContent>
            <DialogContentText>Please define discount{'                         '}</DialogContentText>
            <Grid item xs={12} md={12} xl={12}>
              <TextField
                label={<IntlMessages id="res.discount" />}
                id="discount"
                name="discount"
                fullWidth
                margin="normal"
                className={classes.currency}
                value={this.state.appDiscount}
                onChange={event => this.handleChange('appDiscount', event.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={12} xl={12}>
              <TextField
                id="type"
                label=<IntlMessages id="cockpit.reason" />
                value={this.state.discountMode}
                fullWidth
                select
                disabled={false}
                onChange={event => this.handleChange('discountMode', event.target.value)}>
                <MenuItem value={1}>
                  <IntlMessages id="modify1" />
                </MenuItem>
                <MenuItem value={2}>
                  <IntlMessages id="modify2" />
                </MenuItem>
                <MenuItem value={3}>
                  <IntlMessages id="modify3" />
                </MenuItem>
                <MenuItem value={4}>
                  <IntlMessages id="modify4" />
                </MenuItem>
                <MenuItem value={5}>
                  <IntlMessages id="modify5" />
                </MenuItem>
                <MenuItem value={6}>
                  <IntlMessages id="modify6" />
                </MenuItem>
                <MenuItem value={7}>
                  <IntlMessages id="modify7" />
                </MenuItem>

                <MenuItem value={8}>
                  <IntlMessages id="modify8" />
                </MenuItem>
                <MenuItem value={9}>
                  <IntlMessages id="modify9" />
                </MenuItem>
                <MenuItem value={10}>
                  <IntlMessages id="modify10" />
                </MenuItem>
                <MenuItem value={11}>
                  <IntlMessages id="modify11" />
                </MenuItem>

                <MenuItem value={12}>
                  <IntlMessages id="modify12" />
                </MenuItem>
                <MenuItem value={13}>
                  <IntlMessages id="modify13" />
                </MenuItem>
                <MenuItem value={14}>
                  <IntlMessages id="modify14" />
                </MenuItem>
                <MenuItem value={15}>
                  <IntlMessages id="modify15" />
                </MenuItem>
              </TextField>
            </Grid>

            {this.state.discountMode == 0 && (
              <Grid item xs={12} md={12} xl={12}>
                <TextField
                  id="type"
                  label=<IntlMessages id="cockpit.reason" />
                  value={this.state.reason}
                  fullWidth
                  disabled={false}
                  onChange={event => this.handleChange('reason', event.target.value)}
                />
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ extrasDiscountVisible: false })}>Cancel</Button>
            <Button onClick={e => this.handleClick(e, 'modifyEDiscount2')}>Apply</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.refundDialog} onClose={() => this.setState({ refundDialog: false })}>
          <DialogTitle>Refund</DialogTitle>
          <DialogContent>
            <DialogContentText>Please insert amount to initate refund.</DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              value={this.state.refundAmount}
              id="name"
              label="Amount"
              fullWidth
              variant="standard"
              onChange={event => this.handleChange('refundAmount', event.target.value, -1, 0)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ refundDialog: false })}>Cancel</Button>
            <Button onClick={e => this.handleClick(e, 'refund')}>Refund</Button>
          </DialogActions>
        </Dialog>

        <ModifyRoom
          resRoom={this.state.selReservationRoom}
          open={this.state.modifyRoomVisible}
          anchorEl={this.state.myanchorEl}
          /*moveFolio={p => {
            this.eventClick('moveFolioItem2', p);
          }}*/
          doRefresh={p => {
            this.refresh();
          }}
          setState={p => {
            this.setState(p);
          }}
          setState2={p => {
            this.props.setState(p);
          }}
          doRefresh2={p => {
            this.props.doRefresh();
          }}
        />
        <AddRoom
          resRoom={this.state.selReservationRoom}
          res={this.state.selReservation}
          open={this.state.addRoomVisible}
          agencyId={this.state.agencyId}
          anchorEl={this.state.myanchorEl}
          /*moveFolio={p => {
      this.eventClick('moveFolioItem2', p);
    }}*/
          doRefresh={p => {
            this.refresh();
          }}
          setState={p => {
            this.setState(p);
          }}
          setState2={p => {
            this.props.setState(p);
          }}
          doRefresh2={p => {
            this.props.doRefresh();
          }}
        />
        <ViewTAClient
          resId={-1}
          open={this.state.viewTAVisible}
          anchorEl={this.state.myanchorEl}
          setState={p => {
            this.setState(p);
          }}
          handleChange={p => {
            this.handleAction('agencyId', p);
          }}
        />

        <Invoice
          mode={this.state.invoiceMode}
          resId={this.state.invoiceId}
          hotelId={this.state.hotel_id}
          bookingId={this.state.selReservationId}
          open={this.state.viewInvoiceVisible}
          viewMode={0}
          prepayment={this.state.createPrepayment}
          doRefresh={p => {
            this.refresh();
            this.setState({ tabroom: 5 });
          }}
          setState={p => {
            this.setState(p);
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(ResDetails)));
